import { flatObjectAll } from '../script.js'

let language = {
	amap: {
		child: {
			cacc1: {
				zh: "设备名称：",
				en: "Device Name:",
				vi: "Tên thiết bị",
				ru: "Имя устройства:"
			},
			cacc2: {
				zh: "所属机构：",
				en: "Affiliation:",
				vi: "liên kết",
				ru: "Присоединение:"
			},
			cacc3: {
				zh: "分辨率：",
				en: "Resolution:",
				vi: "Độ phân giải",
				ru: "Разрешение:"
			},
			cacc4: {
				zh: "内存空间：",
				en: "Memory Space:",
				vi: "Không gian bộ nhớ",
				ru: "Объем памяти:"
			},
			cacc5: {
				zh: "版本号：",
				en: "version number:",
				vi: "số phiên bản",
				ru: "номер версии:"
			},
			cacc6: {
				zh: "备注：",
				en: "Remark:",
				vi: "Nhận xét",
				ru: "Замечание:"
			},
			cacc7: {
				zh: "运行状态：",
				en: "Operating status:",
				vi: "Trạng thái hoạt động",
				ru: "Рабочее состояние:"
			},
			cacc8: {
				zh: "连续运行：",
				en: "continue to operate:",
				vi: "tiếp tục hoạt động",
				ru: "продолжает работать:"
			},
			cacc9: {
				zh: "最近心跳：",
				en: "Recent heartbeat:",
				vi: "Nhịp tim gần đây",
				ru: "Недавнее сердцебиение:"
			},
			cacc10: {
				zh: "盒子时钟：",
				en: "Box Clock:",
				vi: "Đồng hồ hộp",
				ru: "Встроенные часы:"
			},
			cacc11: {
				zh: "IP地址：",
				en: "IP Address:",
				vi: "Địa chỉ IP",
				ru: "ip-адрес:"
			},
			cacc12: {
				zh: "音量：",
				en: "volume:",
				vi: "âm lượng",
				ru: "громкость:"
			},
			cacc13: {
				zh: "暂无数据",
				en: "No data",
				vi: "Không có dữ liệu",
				ru: "Нет данных"
			},
			cacc14: {
				zh: "亮度：",
				en: "brightness:",
				vi: "độ sáng",
				ru: "о яркости:"
			},
			cacc15: {
				zh: "请输入0-100的数字",
				en: "Please enter a number between 0 and 100",
				vi: "Vui lòng nhập số từ 0 đến 100",
				ru: "Пожалуйста, введите число от 0 до 100"
			}
		},
		dialog: {
			cadd1: {
				zh: "截图",
				en: "screenshot",
				vi: "Hình ảnh",
				ru: "скриншот"
			},
			cadd2: {
				zh: "节目单名称",
				en: "Program name",
				vi: "Tên chương trình",
				ru: "Название программы"
			},
			cadd3: {
				zh: "组织结构",
				en: "Organizational Structure",
				vi: "Cơ cấu tổ chức",
				ru: "Организационная структура"
			},
			cadd4: {
				zh: "分辨率",
				en: "Resolution",
				vi: "Độ phân giải",
				ru: "Разрешение:"
			},
			cadd5: {
				zh: "模版名称",
				en: "Template Name",
				vi: "Tên mẫu",
				ru: "Название шаблона"
			},
			cadd6: {
				zh: "创建时间",
				en: "Creation time",
				vi: "Thời gian khởi tạo",
				ru: "Время создания"
			},
			cadd7: {
				zh: "终端名称",
				en: "Terminal Name",
				vi: "Tên thiết bị đầu cuối",
				ru: "Название терминала"
			},
			cadd8: {
				zh: "组织结构",
				en: "Organizational Structure",
				vi: "Cơ cấu tổ chức",
				ru: "Организационная структура"
			},
			cadd9: {
				zh: "分辨率",
				en: "Resolution",
				vi: "Độ phân giải",
				ru: "Разрешение:"
			},
			cadd10: {
				zh: "设备类型",
				en: "Equipment type",
				vi: "Loại thiết bị",
				ru: "Тип оборудования"
			},
			cadd11: {
				zh: "业务属性",
				en: "Business attributes",
				vi: "Thuộc tính nghiệp vụ",
				ru: "Бизнес-атрибуты"
			},
			cadd12: {
				zh: "请输入关键词",
				en: "Please enter a keyword",
				vi: "Vui lòng nhập từ khóa",
				ru: "Пожалуйста, введите ключевое слово"
			},
			cadd13: {
				zh: "请输入设备名",
				en: "Please enter the device name",
				vi: "Vui lòng nhập tên thiết bị",
				ru: "Пожалуйста, введите название устройства"
			},
			cadd14: {
				zh: "标题",
				en: "title",
				vi: "tiêu đề",
				ru: "название"
			},
			cadd15: {
				zh: "未知错误",
				en: "unknown mistake",
				vi: "lỗi không xác định",
				ru: "неизвестно, ошибка"
			},
			cadd16: {
				zh: "选择节目单",
				en: "Select program",
				vi: "Chọn chương trình",
				ru: "Выберите программу"
			},
			cadd17: {
				zh: "选择设备",
				en: "Select device",
				vi: "Chọn thiết bị",
				ru: "Выберите устройство"
			}
		},
		caa1: {
			zh: "请输入搜索关键词",
			en: "Enter search keywords",
			vi: "Nhập từ khóa tìm kiếm",
			ru: "Введите ключевые слова для поиск"
		},
		caa2: {
			zh: "未搜索到地址信息",
			en: "No address information found",
			vi: "Không tìm thấy thông tin địa chỉ",
			ru: "Адресная информация не найдена"
		},
		caa3: {
			zh: "收起搜索结果",
			en: "Collapse Search Results",
			vi: "Thu gọn kết quả tìm kiếm",
			ru: "Свернуть результаты поиска"
		},
		caa4: {
			zh: "详细地址：",
			en: "Address:",
			vi: "Địa chỉ",
			ru: "Адрес:"
		},
		caa5: {
			zh: "经度：",
			en: "longitude:",
			vi: "kinh độ",
			ru: "долгота:"
		},
		caa6: {
			zh: "纬度：",
			en: "latitude:",
			vi: "vĩ độ",
			ru: "широта:"
		},
		caa7: {
			zh: "请在地图上选择设备所在地",
			en: "Please select the location of the device on the map",
			vi: "Vui lòng chọn vị trí của thiết bị trên bản đồ",
			ru: "Пожалуйста, выберите местоположение устройства на карте"
		},
		caa8: {
			zh: "一号设备",
			en: "Equipment No. 1",
			vi: "Thiết bị số 1",
			ru: "Оборудование № 1"
		},
		caa9: {
			zh: "高德地图信息错误",
			en: "Amap information error",
			vi: "Lỗi thông tin Amap",
			ru: "Ошибка в информации Amap"
		},
		caa10: {
			zh: "所选地址非精确坐标点，请重新选择",
			en: "The selected address is not an accurate coordinate point, please reselect",
			vi: "Địa chỉ đã chọn không phải là điểm tọa độ chính xác, vui lòng chọn lại",
			ru: "Выбранный адрес не соответствует точным координатам, пожалуйста, выберите его повторно"
		}
	},
	basics: {
		AddDialog: {
			cba1: {
				zh: "标 题",
				en: "Title",
				vi: "Tiêu đề",
				ru: "Заглавие"
			}
		},
		DateSet: {
			cbb1: {
				zh: "执行时间",
				en: "execution time",
				vi: "thời gian thực hiện",
				ru: "Время выполнения"
			},
			cbb2: {
				zh: "日期",
				en: "date",
				vi: "ngày",
				ru: "дату"
			},
			cbb3: {
				zh: "选择日期",
				en: "Select Date",
				vi: "Chọn ngày",
				ru: "Выберите дату"
			},
			cbb4: {
				zh: "至",
				en: "to",
				vi: "Đến",
				ru: "до"
			},
			cbb5: {
				zh: "每周",
				en: "weekly",
				vi: "hàng tuần",
				ru: "каждая неделя"
			}
		},
		Trees: {
			cbt1: {
				zh: "请输入关键字",
				en: "Please enter key words",
				vi: "Vui lòng nhập từ khóa",
				ru: "Пожалуйста, введите ключевые слова"
			},
			cbt2: {
				zh: "获取全部资源",
				en: "Get all resources",
				vi: "Nhận tất cả các nguồn",
				ru: "Получить все ресурсы"
			},
			cbt3: {
				zh: "获取全部类型",
				en: "Get all types",
				vi: "Nhận tất cả các loại",
				ru: "Получить все типы"
			},
			cbt4: {
				zh: "删除",
				en: "delete",
				vi: "xóa bỏ",
				ru: "удалить"
			},
			cbt5: {
				zh: "重命名",
				en: "Rename",
				vi: "Đổi tên",
				ru: "Переименовать"
			}
		},
		UploadingList: {
			cbu1: {
				zh: "终端名称",
				en: "Terminal Name",
				vi: "Tên thiết bị đầu cuối",
				ru: "Название терминала"
			},
			cbu2: {
				zh: "发布进度",
				en: "Release progress",
				vi: "Tiến độ phát hành",
				ru: "Ход выпуска"
			},
			cbu3: {
				zh: "状态",
				en: "state",
				vi: "trạng thái",
				ru: "состояние"
			},
			cbu4: {
				zh: "操作",
				en: "operate",
				vi: "vận hành",
				ru: "работать"
			},
			cbu5: {
				zh: "节目名称",
				en: "Name of programme",
				vi: "Tên chương trình",
				ru: "Название программы"
			},
			cbu6: {
				zh: "分辨率",
				en: "Resolution",
				vi: "Độ phân giải",
				ru: "Разрешение:"
			},
			cbu7: {
				zh: "节目时长",
				en: "Program duration",
				vi: "Thời lượng chương trình",
				ru: "Длительность"
			}
		}
	},
	device: {
		children: {
			AcquisitionDevice: {
				cdca1: {
					zh: "服务器列表",
					en: "server list",
					vi: "danh sách máy chủ",
					ru: "список серверов"
				},
				cdca2: {
					zh: "获取设备",
					en: "Get the device",
					vi: "Nhận thiết bị",
					ru: "Получить устройство"
				},
				cdca3: {
					zh: "确定",
					en: "Sure",
					vi: "Chắc chắn",
					ru: "уверенный"
				},
				cdca4: {
					zh: "序号",
					en: "Serial number",
					vi: "Số seri",
					ru: "Серийный номер"
				},
				cdca5: {
					zh: "设备名称",
					en: "Device Name",
					vi: "Tên thiết bị",
					ru: "Имя устройства:"
				},
				cdca6: {
					zh: "位置",
					en: "Location",
					vi: "Vị trí",
					ru: "Местоположение"
				},
				cdca7: {
					zh: "分辨率",
					en: "Resolution",
					vi: "Độ phân giải",
					ru: "Разрешение:"
				},
				cdca8: {
					zh: "状态",
					en: "state",
					vi: "Trạng thái",
					ru: "состояние"
				},
				cdca9: {
					zh: "普通",
					en: "ordinary",
					vi: "bình thường",
					ru: "обычный"
				},
				cdca10: {
					zh: "已同步",
					en: "Synchronized",
					vi: "Đã đồng bộ hóa",
					ru: "Синхронизированный"
				},
				cdca11: {
					zh: "未同步",
					en: "Not synced",
					vi: "Chưa được đồng bộ hóa",
					ru: "Несинхронизированный"
				}
			},
			ExportDialog: {
				cdce1: {
					zh: "导出日志",
					en: "Export logs",
					vi: "Xuất nhật ký",
					ru: "Экспорт журналов"
				},
				cdce2: {
					zh: "日期范围：",
					en: "Date Range:",
					vi: "Phạm vi ngày",
					ru: "Диапазон дат:"
				},
				cdce3: {
					zh: "至",
					en: "to",
					vi: "ĐẾN",
					ru: "до"
				},
				cdce4: {
					zh: "开始日期",
					en: "start date",
					vi: "ngày bắt đầu",
					ru: "даты начала"
				},
				cdce5: {
					zh: "结束日期",
					en: "End Date",
					vi: "Ngày cuối",
					ru: "Дата окончания"
				},
				cdce6: {
					zh: "确定",
					en: "Sure",
					vi: "Chắc chắn",
					ru: "уверенный"
				},
				cdce7: {
					zh: "取消",
					en: "Cancel",
					vi: "Hủy bỏ",
					ru: "Отменить"
				},
				cdce8: {
					zh: "设备名称",
					en: "Device Name",
					vi: "Tên thiết bị",
					ru: "Название устройства"
				},
				cdce9: {
					zh: "设备SN",
					en: "Equipment SN",
					vi: "Thiết bị SN",
					ru: "оборудования SN"
				},
				cdce10: {
					zh: "组织结构",
					en: "Organizational Structure",
					vi: "Cơ cấu tổ chức",
					ru: "Организационная структура"
				},
				cdce11: {
					zh: "类型",
					en: "type",
					vi: "Loại",
					ru: "тип"
				},
				cdce12: {
					zh: "操作时间",
					en: "Operation time",
					vi: "Thời gian hoạt động",
					ru: "Время работы"
				},
				cdce13: {
					zh: "日志.xlsx",
					en: "Log.xlsx",
					vi: "Log.xlsx",
					ru: "журнал .xlsx"
				}
			},
			KommanderDetails: {
				cdck1: {
					zh: "设备名称：",
					en: "Device Name:",
					vi: "Tên thiết bị",
					ru: "Имя устройства:"
				},
				cdck2: {
					zh: "所属机构：",
					en: "Affiliation:",
					vi: "liên kết",
					ru: "Присоединение:"
				},
				cdck3: {
					zh: "分辨率：",
					en: "Resolution:",
					vi: "Độ phân giải",
					ru: "Разрешение:"
				},
				cdck4: {
					zh: "运行状态：",
					en: "Operating status:",
					vi: "Trạng thái hoạt động",
					ru: "Рабочее состояние:"
				},
				cdck5: {
					zh: "最近心跳：",
					en: "Recent heartbeat:",
					vi: "Nhịp tim gần đây",
					ru: "Недавнее сердцебиение:"
				},
				cdck6: {
					zh: "节目排期",
					en: "Program Schedule",
					vi: "Lập lịch trình chương trình",
					ru: "Расписание программы"
				},
				cdck7: {
					zh: "节目名称",
					en: "Name of programme",
					vi: "Tên chương trình",
					ru: "Название программы"
				},
				cdck8: {
					zh: "有效日期",
					en: "Effective Date",
					vi: "Ngày có hiệu lực",
					ru: "дата вступления в силу"
				},
				cdck9: {
					zh: "有效星期",
					en: "Valid week",
					vi: "Tuần có hiệu lực",
					ru: "Действительная неделя"
				},
				cdck10: {
					zh: "播放时间",
					en: "play time",
					vi: "Thời gian phát",
					ru: "Время игры"
				},
				cdck11: {
					zh: "节目列表",
					en: "Programme list",
					vi: "Danh sách chương trình",
					ru: "Список программ"
				},
				cdck12: {
					zh: "序号",
					en: "Serial number",
					vi: "Số seri",
					ru: "Серийный номер"
				},
				cdck13: {
					zh: "节目名称",
					en: "Name of programme",
					vi: "Tên chương trình",
					ru: "Название программы"
				},
				cdck14: {
					zh: "在播预览",
					en: "Preview on Play",
					vi: "Xem trước trên Play",
					ru: "Предварительный просмотр при воспроизведении"
				},
				cdck15: {
					zh: "拼命加载中",
					en: "Loading",
					vi: "Đang tải",
					ru: "Погрузка"
				},
				cdck16: {
					zh: "暂无信号，请稍后再试!",
					en: "No signal, please try again later!",
					vi: "Không có tín hiệu, vui lòng thử lại sau!",
					ru: "Нет сигнала, пожалуйста, повторите попытку позже!"
				},
				cdck17: {
					zh: "离线",
					en: "Offline",
					vi: "Offline",
					ru: "Не в сети"
				},
				cdck18: {
					zh: "节目排期",
					en: "Program Schedule",
					vi: "Lập lịch trình chương trình",
					ru: "Расписание программы"
				},
				cdck19: {
					zh: "节目列表",
					en: "Programme list",
					vi: "Danh sách chương trình",
					ru: "Список программ"
				},
				cdck20: {
					zh: "在播预览",
					en: "Preview on Play",
					vi: "Xem trước trên Play",
					ru: "Предварительный просмотр при воспроизведении"
				}
			},
			PandoraDetails: {
				cdcp1: {
					zh: "音量",
					en: "volume",
					vi: "âm lượng",
					ru: "громкость:"
				},
				cdcp2: {
					zh: "亮度",
					en: "brightness",
					vi: "độ sáng",
					ru: "яркость"
				},
				cdcp3: {
					zh: "节目排期",
					en: "Program Schedule",
					vi: "Lập lịch trình chương trình",
					ru: "Расписание программы"
				},
				cdcp4: {
					zh: "节目名称",
					en: "Name of programme",
					vi: "Tên chương trình",
					ru: "Название программы"
				},
				cdcp5: {
					zh: "指令等级",
					en: "Instruction level",
					vi: "Cấp độ hướng dẫn",
					ru: "Уровень обучения"
				},
				cdcp6: {
					zh: "执行时间",
					en: "execution time",
					vi: "thời gian thực hiện",
					ru: "время выполнения"
				},
				cdcp7: {
					zh: "有效日期",
					en: "Effective Date",
					vi: "Ngày có hiệu lực",
					ru: "дата вступления в силу"
				},
				cdcp8: {
					zh: "有效星期",
					en: "Valid week",
					vi: "Tuần có hiệu lực",
					ru: "Действительная неделя"
				},
				cdcp9: {
					zh: "连播次数",
					en: "Number of consecutive broadcasts",
					vi: "Số lần phát sóng liên tiếp",
					ru: "Количество последовательных передач"
				},
				cdcp10: {
					zh: "节目列表",
					en: "Programme list",
					vi: "Danh sách chương trình",
					ru: "Список программ"
				},
				cdcp11: {
					zh: "序号",
					en: "Serial number",
					vi: "Số seri",
					ru: "Серийный номер"
				},
				cdcp12: {
					zh: "截屏",
					en: "screenshot",
					vi: "ảnh chụp màn hình",
					ru: "скриншот"
				},
				cdcp13: {
					zh: "操作指令",
					en: "Operation Instructions",
					vi: "Hướng dẫn vận hành",
					ru: "Инструкции по эксплуатации"
				},
				cdcp14: {
					zh: "值",
					en: "value",
					vi: "giá trị",
					ru: "ценность"
				},
				cdcp15: {
					zh: "执行时间",
					en: "execution time",
					vi: "thời gian thực hiện",
					ru: "время выполнения"
				},
				cdcp16: {
					zh: "设备ID",
					en: "Device ID",
					vi: "ID thiết bị",
					ru: "Идентификатор устройства"
				},
				cdcp17: {
					zh: "设备名称",
					en: "Device Name",
					vi: "Tên thiết bị",
					ru: "Имя устройства:"
				},
				cdcp18: {
					zh: "所属机构",
					en: "Affiliation",
					vi: "liên kết",
					ru: "Присоединение:"
				},
				cdcp19: {
					zh: "分辨率",
					en: "Resolution",
					vi: "Độ phân giải",
					ru: "Разрешение:"
				},
				cdcp20: {
					zh: "屏幕类型",
					en: "Screen type",
					vi: "Loại màn hình",
					ru: "Тип экрана"
				},
				cdcp21: {
					zh: "业务类型",
					en: "business type",
					vi: "Loại hình nghiệp vụ",
					ru: "тип бизнеса"
				},
				cdcp22: {
					zh: "开屏时间",
					en: "Screen time",
					vi: "Thời gian sử dụng màn hình",
					ru: "Экранное время"
				},
				cdcp23: {
					zh: "关屏时间",
					en: "Screen off time",
					vi: "Thời gian tắt màn hình",
					ru: "Время выключения экрана"
				},
				cdcp24: {
					zh: "内存空间",
					en: "Memory space",
					vi: "Không gian bộ nhớ",
					ru: "Объем памяти:"
				},
				cdcp25: {
					zh: "版本号",
					en: "version number",
					vi: "số phiên bản",
					ru: "номер версии:"
				},
				cdcp26: {
					zh: "运行状态",
					en: "Operating status",
					vi: "Trạng thái hoạt động",
					ru: "Рабочее состояние:"
				},
				cdcp27: {
					zh: "连续运行",
					en: "continue to operate",
					vi: "tiếp tục hoạt động",
					ru: "продолжайте работать"
				},
				cdcp28: {
					zh: "盒子时钟",
					en: "Box Clock",
					vi: "Đồng hồ hộp",
					ru: "Часы-шкатулка"
				},
				cdcp29: {
					zh: "IP地址",
					en: "IP address",
					vi: "địa chỉ IP",
					ru: "ip-адрес"
				},
				cdcp30: {
					zh: "最近心跳",
					en: "Recent heartbeat",
					vi: "Nhịp tim gần đây",
					ru: "Недавнее сердцебиение"
				},
				cdcp31: {
					zh: "音量",
					en: "volume",
					vi: "âm lượng",
					ru: "громкость"
				},
				cdcp32: {
					zh: "亮度",
					en: "brightness",
					vi: "độ sáng",
					ru: "яркость"
				},
				cdcp33: {
					zh: "未设置日期",
					en: "No date set",
					vi: "Không có ngày nào được thiết lập",
					ru: "Дата не установлена"
				},
				cdcp34: {
					zh: "未设置星期",
					en: "Day of the week not set",
					vi: "Không có ngày nào trong tuần được thiết lập",
					ru: "Неделя не установлена"
				},
				cdcp35: {
					zh: "在线",
					en: "Online",
					vi: "Online",
					ru: "онлайн"
				},
				cdcp36: {
					zh: "离线",
					en: "Offline",
					vi: "Offline",
					ru: "не в сети"
				},
				cdcp37: {
					zh: "未设置",
					en: "Not set",
					vi: "Không được thiết lập",
					ru: "Не установлен"
				},
				cdcp38: {
					zh: "设备离线-暂无数据",
					en: "Device offline - no data",
					vi: "Thiết bị ngoại tuyến - không có dữ liệu",
					ru: "Устройство находится в автономном режиме - данные недоступны"
				},
				cdcp39: {
					zh: "亮度调节",
					en: "Dimming",
					vi: "Điều chỉnh độ sáng",
					ru: "Регулировка яркости"
				},
				cdcp40: {
					zh: "音量调节",
					en: "Volume adjustment",
					vi: "Điều chỉnh âm lượng",
					ru: "Регулировка громкости"
				},
				cdcp41: {
					zh: "关闭屏幕",
					en: "Turn off screen",
					vi: "Tắt màn hình",
					ru: "Выключите экран"
				},
				cdcp42: {
					zh: "开启屏幕",
					en: "Turn on screen",
					vi: "Bật màn hình",
					ru: "Включите экран"
				},
				cdcp43: {
					zh: "无状态",
					en: "no status",
					vi: "không có trạng thái",
					ru: "Без гражданства"
				}
			}
		},
		TerminalControl: {
			cdt1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры"
			},
			cdt2: {
				zh: "命令菜单",
				en: "Command Menu",
				vi: "Menu lệnh",
				ru: "Командное меню"
			},
			cdt3: {
				zh: "在线：",
				en: "Online:",
				vi: "Online",
				ru: "онлайн："
			},
			cdt4: {
				zh: "离线：",
				en: "Offline:",
				vi: "Offline",
				ru: "не в сети："
			},
			cdt5: {
				zh: "请输入查询内容",
				en: "Please enter your query",
				vi: "Vui lòng nhập truy vấn của bạn",
				ru: "Пожалуйста, введите содержание запроса"
			},
			cdt6: {
				zh: "终端名称",
				en: "Terminal Name",
				vi: "Tên thiết bị đầu cuối",
				ru: "Название терминала"
			},
			cdt7: {
				zh: "备注",
				en: "Remark",
				vi: "Nhận xét",
				ru: "Замечания"
			},
			cdt8: {
				zh: "组织结构",
				en: "Organizational Structure",
				vi: "Cơ cấu tổ chức",
				ru: "структура"
			},
			cdt9: {
				zh: "分辨率",
				en: "Resolution",
				vi: "Nghị quyết",
				ru: "разрешение"
			},
			cdt10: {
				zh: "状态",
				en: "state",
				vi: "tình trạng",
				ru: "состояние"
			},
			cdt11: {
				zh: "操作",
				en: "operate",
				vi: "vận hành",
				ru: "работать"
			},
			cdt12: {
				zh: "提示",
				en: "hint",
				vi: "gợi ý",
				ru: "подсказка"
			},
			cdt13: {
				zh: "紧急插播",
				en: "Emergency Interruption",
				vi: "Gián đoạn khẩn cấp",
				ru: "Экстренный интерстициальный"
			},
			cdt14: {
				zh: "取 消",
				en: "Cancel",
				vi: "Hủy bỏ",
				ru: "отменять"
			},
			cdt15: {
				zh: "确 定",
				en: "Sure",
				vi: "Chắc chắn",
				ru: "определять"
			},
			cdt16: {
				zh: "控制筛选",
				en: "Control Filter",
				vi: "Bộ lọc điều khiển",
				ru: "Контрольная фильтрация"
			},
			cdt17: {
				zh: "全选",
				en: "select all",
				vi: "chọn tất cả",
				ru: "Выбрать все"
			},
			cdt18: {
				zh: "添加排程",
				en: "Add Schedule",
				vi: "Thêm lịch trình",
				ru: "Добавить расписание"
			},
			cdt19: {
				zh: "请选择模板",
				en: "Please select a template",
				vi: "Vui lòng chọn một mẫu",
				ru: "Пожалуйста, выберите шаблон"
			},
			cdt20: {
				zh: "切换模板时请保存修改，否则将会丢失修改！",
				en: "Please save your changes when switching templates, otherwise they will be lost!",
				vi: "Vui lòng lưu các thay đổi của bạn khi chuyển đổi mẫu, nếu không chúng sẽ bị mất!",
				ru: "Пожалуйста, сохраняйте изменения при переключении шаблонов, иначе они будут потеряны!"
			},
			cdt21: {
				zh: "请选择模板或创建新的模板后，添加排程！",
				en: "Please select a template or create a new one, then add a schedule!",
				vi: "Vui lòng chọn mẫu hoặc tạo mẫu mới, sau đó thêm lịch trình!",
				ru: "Пожалуйста, выберите шаблон или создайте новый шаблон, чтобы добавить расписание!"
			},
			cdt22: {
				zh: "操作指令",
				en: "Operation Instructions",
				vi: "Hướng dẫn vận hành",
				ru: "Инструкции по эксплуатации"
			},
			cdt23: {
				zh: "设置值",
				en: "Settings",
				vi: "Cài đặt",
				ru: "Установленное значение"
			},
			cdt24: {
				zh: "执行时间",
				en: "execution time",
				vi: "thời gian thực hiện",
				ru: "Время выполнения"
			},
			cdt25: {
				zh: "有效日期",
				en: "Effective Date",
				vi: "Ngày có hiệu lực",
				ru: "Дата вступления в силу"
			},
			cdt26: {
				zh: "有限制",
				en: "limited",
				vi: "giới hạn",
				ru: "ограниченный"
			},
			cdt27: {
				zh: "创建模板",
				en: "Create a template",
				vi: "Tạo một mẫu",
				ru: "Создать шаблон"
			},
			cdt28: {
				zh: "保存模板",
				en: "Save Template",
				vi: "Lưu mẫu",
				ru: "Сохранить шаблон"
			},
			cdt29: {
				zh: "发送排程",
				en: "Send Schedule",
				vi: "Gửi lịch trình",
				ru: "Расписание отправки"
			},
			cdt30: {
				zh: "取消",
				en: "Cancel",
				vi: "Hủy bỏ",
				ru: "отменять"
			},
			cdt31: {
				zh: "创建排程模板",
				en: "Create a schedule template",
				vi: "Tạo mẫu lịch trình",
				ru: "Создайте шаблон планирования"
			},
			cdt32: {
				zh: "模板名称",
				en: "Template Name",
				vi: "Tên mẫu",
				ru: "Имя шаблона"
			},
			cdt33: {
				zh: "新增定时指令",
				en: "Added timing instructions",
				vi: "Đã thêm hướng dẫn về thời gian",
				ru: "Добавлена команда синхронизации"
			},
			cdt34: {
				zh: "操作指令",
				en: "Operation Instructions",
				vi: "Hướng dẫn vận hành",
				ru: "Инструкции по эксплуатации"
			},
			cdt35: {
				zh: "请选择指令",
				en: "Please select the command",
				vi: "Hãy chọn lệnh",
				ru: "Пожалуйста, выберите инструкцию"
			},
			cdt36: {
				zh: "请设置屏幕操作时间",
				en: "Please set the screen time",
				vi: "Vui lòng đặt thời gian sử dụng màn hình",
				ru: "Пожалуйста, установите время работы экрана"
			},
			cdt37: {
				zh: "紧急停止",
				en: "emergency stop",
				vi: "dừng khẩn cấp",
				ru: "аварийная остановка"
			},
			cdt38: {
				zh: "紧急插播",
				en: "Emergency Interruption",
				vi: "Gián đoạn khẩn cấp",
				ru: "Экстренный интерстициальный"
			},
			cdt39: {
				zh: "添加排程",
				en: "Add Schedule",
				vi: "Thêm lịch trình",
				ru: "Добавить расписание"
			},
			cdt40: {
				zh: "重新启动",
				en: "Restart",
				vi: "Khởi động lại",
				ru: "перезапустить"
			},
			cdt41: {
				zh: "开启屏幕",
				en: "Turn on screen",
				vi: "Bật màn hình",
				ru: "Включите экран"
			},
			cdt42: {
				zh: "关闭屏幕",
				en: "Turn off screen",
				vi: "Tắt màn hình",
				ru: "Выключите экран"
			},
			cdt43: {
				zh: "亮度调节",
				en: "Dimming",
				vi: "Điều chỉnh độ sáng",
				ru: "Регулировка яркости"
			},
			cdt44: {
				zh: "音量调节",
				en: "Volume adjustment",
				vi: "Điều chỉnh âm lượng",
				ru: "Регулировка громкости"
			},
			cdt45: {
				zh: "设备尺寸",
				en: "Equipment size",
				vi: "Kích thước thiết bị",
				ru: "Размер оборудования"
			},
			cdt46: {
				zh: "设备状态",
				en: "device status",
				vi: "trạng thái thiết bị",
				ru: "Состояние устройства"
			},
			cdt47: {
				zh: "在线",
				en: "Online",
				vi: "Trực tuyến",
				ru: "онлайн"
			},
			cdt48: {
				zh: "离线",
				en: "Offline",
				vi: "Ngoại tuyến",
				ru: "не в сети"
			},
			cdt49: {
				zh: "设备已紧急停止！",
				en: "The equipment has stopped urgently!",
				vi: "Thiết bị đã dừng khẩn cấp!",
				ru: "Оборудование было срочно остановлено!"
			},
			cdt50: {
				zh: "请选择终端设备！",
				en: "Please select the terminal device!",
				vi: "Vui lòng chọn thiết bị đầu cuối!",
				ru: "Пожалуйста, выберите оконечное устройство!"
			},
			cdt51: {
				zh: "设备已重新启动！",
				en: "The device has restarted!",
				vi: "Thiết bị đã khởi động lại!",
				ru: "Устройство было перезапущено!"
			},
			cdt52: {
				zh: "创建排程模板成功！",
				en: "The scheduling template was created successfully!",
				vi: "Mẫu lịch trình đã được tạo thành công!",
				ru: "Создание шаблона планирования прошло успешно!"
			},
			cdt53: {
				zh: "定时指令开始时间不可以大于结束时间",
				en: "The start time of the timing instruction cannot be greater than the end time",
				vi: "Thời gian bắt đầu của lệnh tính giờ không thể lớn hơn thời gian kết thúc",
				ru: "Время начала выполнения команды синхронизации не может быть больше времени окончания"
			},
			cdt54: {
				zh: "此操作将永久删除该模板, 是否继续?",
				en: "This operation will permanently delete the template, do you want to continue?",
				vi: "Thao tác này sẽ xóa vĩnh viễn mẫu, bạn có muốn tiếp tục không?",
				ru: "Эта операция приведет к необратимому удалению шаблона, будет ли она продолжена?"
			},
			cdt55: {
				zh: "提示",
				en: "hint",
				vi: "gợi ý",
				ru: "подсказка"
			},
			cdt56: {
				zh: "删除成功",
				en: "successfully deleted",
				vi: "đã xóa thành công",
				ru: "Успешно удален"
			},
			cdt57: {
				zh: "模板保存成功!",
				en: "Template saved successfully!",
				vi: "Đã lưu mẫu thành công!",
				ru: "Шаблон был успешно сохранен!"
			},
			cdt58: {
				zh: "未选中任何设备",
				en: "No devices selected",
				vi: "Không có thiết bị nào được chọn",
				ru: "Устройство не выбрано"
			},
			cdt59: {
				zh: "group_id不存在!",
				en: "group_id does not exist!",
				vi: "nhóm_id không tồn tại!",
				ru: "идентификатор_группы не существует!"
			}
		},
		TerminalLog__beifen: {
			cdtb1: {
				zh: "请输入关键字",
				en: "Please enter key words",
				vi: "Vui lòng nhập từ khóa",
				ru: "Пожалуйста, введите ключевые слова"
			},
			cdtb2: {
				zh: "开始日期",
				en: "start date",
				vi: "ngày bắt đầu",
				ru: "Дата начала"
			},
			cdtb3: {
				zh: "结束日期",
				en: "End Date",
				vi: "Ngày cuối",
				ru: "Дата окончания"
			},
			cdtb4: {
				zh: "发布单号查询",
				en: "Release order number query",
				vi: "Truy vấn số thứ tự phát hành",
				ru: "Запрос на публикацию номера заказа"
			},
			cdtb5: {
				zh: "设备名称",
				en: "Device Name",
				vi: "Tên thiết bị",
				ru: "Имя устройства"
			},
			cdtb6: {
				zh: "设备SN",
				en: "Equipment SN",
				vi: "Thiết bị SN",
				ru: "Оборудование SN"
			},
			cdtb7: {
				zh: "组织结构",
				en: "Organizational Structure",
				vi: "Cơ cấu tổ chức",
				ru: "структура"
			},
			cdtb8: {
				zh: "类型",
				en: "type",
				vi: "kiểu",
				ru: "тип"
			},
			cdtb9: {
				zh: "操作时间",
				en: "Operation time",
				vi: "Thời gian hoạt động",
				ru: "Время работы"
			},
			cdtb10: {
				zh: "操作用户",
				en: "Operation User",
				vi: "Người dùng thao tác",
				ru: "Действующий пользователь"
			},
			cdtb11: {
				zh: "功能",
				en: "Function",
				vi: "Chức năng",
				ru: "функция"
			},
			cdtb12: {
				zh: "描述",
				en: "describe",
				vi: "mô tả",
				ru: "описание"
			},
			cdtb13: {
				zh: "确定...",
				en: "Sure...",
				vi: "Chắc chắn...",
				ru: "уверенный..."
			},
			cdtb14: {
				zh: "终端退出了",
				en: "The terminal exited",
				vi: "Thiết bị đầu cuối đã thoát",
				ru: "Терминал вышел из строя"
			},
			cdtb15: {
				zh: "退出",
				en: "quit",
				vi: "Thoát",
				ru: "выходить из"
			},
			cdtb16: {
				zh: "终端登录了",
				en: "Terminal logged in",
				vi: "Thiết bị đầu cuối đã đăng nhập",
				ru: "Терминал вошел в систему"
			},
			cdtb17: {
				zh: "登录",
				en: "Log in",
				vi: "Đăng nhập",
				ru: "войти"
			},
			cdtb18: {
				zh: "操作日志",
				en: "Operation log",
				vi: "Nhật ký hoạt động",
				ru: "Журнал операций"
			},
			cdtb19: {
				zh: "导出",
				en: "Export",
				vi: "Xuất",
				ru: "экспорт"
			}
		},
		TerminalLog: {
			cdtl1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры"
			},
			cdtl2: {
				zh: "设备名称",
				en: "Device Name",
				vi: "Tên thiết bị",
				ru: "Имя устройства"
			},
			cdtl3: {
				zh: "设备SN",
				en: "Equipment SN",
				vi: "Thiết bị SN",
				ru: "Оборудование SN"
			},
			cdtl4: {
				zh: "组织结构",
				en: "Organizational Structure",
				vi: "Cơ cấu tổ chức",
				ru: "структура"
			},
			cdtl5: {
				zh: "类型",
				en: "type",
				vi: "Loại",
				ru: "тип"
			},
			cdtl6: {
				zh: "操作时间",
				en: "Operation time",
				vi: "Thời gian hoạt động",
				ru: "Время работы"
			},
			cdtl7: {
				zh: "终端退出了",
				en: "The terminal exited",
				vi: "Thiết bị đầu cuối đã thoát",
				ru: "Терминал вышел из строя"
			},
			cdtl8: {
				zh: "退出",
				en: "quit",
				vi: "Thoát",
				ru: "выходить из"
			},
			cdtl9: {
				zh: "终端登录了",
				en: "Terminal logged in",
				vi: "Thiết bị đầu cuối đã đăng nhập",
				ru: "Терминал вошел в систему"
			},
			cdtl10: {
				zh: "登录",
				en: "Log in",
				vi: "Đăng nhập",
				ru: "войти"
			}
		},
		TerminalManage: {
			cdtm1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры"
			},
			cdtm2: {
				zh: "请选择设备",
				en: "Please select your device",
				vi: "Vui lòng chọn thiết bị của bạn",
				ru: "Пожалуйста, выберите устройство"
			},
			cdtm3: {
				zh: "终端名称",
				en: "Terminal Name",
				vi: "Tên thiết bị đầu cuối",
				ru: "Название терминала"
			},
			cdtm4: {
				zh: "设备类型",
				en: "Equipment type",
				vi: "Loại thiết bị",
				ru: "Тип устройства"
			},
			cdtm5: {
				zh: "组织结构",
				en: "Organizational Structure",
				vi: "Cơ cấu tổ chức",
				ru: "структура"
			},
			cdtm6: {
				zh: "备注信息-1",
				en: "Remarks-1",
				vi: "Nhận xét-1",
				ru: "Замечания-1"
			},
			cdtm7: {
				zh: "分辨率",
				en: "Resolution",
				vi: "Độ phân giải",
				ru: "разрешение"
			},
			cdtm8: {
				zh: "设备状态",
				en: "device status",
				vi: "trạng thái thiết bị",
				ru: "Состояние устройства"
			},
			cdtm9: {
				zh: "离线",
				en: "Offline",
				vi: "Ngoại tuyến",
				ru: "не в сети"
			},
			cdtm10: {
				zh: "请问是否要永久删除当前(选中)终端？",
				en: "Do you want to permanently delete the current (selected) terminal?",
				vi: "Bạn có muốn xóa vĩnh viễn thiết bị đầu cuối hiện tại (đã chọn) không?",
				ru: "Вы хотите навсегда удалить текущий (выбранный) терминал?"
			},
			cdtm11: {
				zh: "当前没有选中任何需要删除的终端！",
				en: "There are currently no terminals selected for deletion!",
				vi: "Hiện tại không có thiết bị đầu cuối nào được chọn để xóa!",
				ru: "В данный момент не выбраны терминалы, которые необходимо удалить!"
			},
			cdtm12: {
				zh: "新增设备",
				en: "New Equipment",
				vi: "Thiết bị mới",
				ru: "Новое оборудование"
			},
			cdtm13: {
				zh: "编辑设备",
				en: "Editing Devices",
				vi: "Chỉnh sửa thiết bị",
				ru: "Монтажное оборудование"
			},
			cdtm14: {
				zh: "设备名称",
				en: "Device Name",
				vi: "Tên thiết bị",
				ru: "Имя устройства"
			},
			cdtm15: {
				zh: "组织结构",
				en: "Organizational Structure",
				vi: "Cơ cấu tổ chức",
				ru: "структура"
			},
			cdtm16: {
				zh: "请选择组织结构",
				en: "Please select your organizational structure",
				vi: "Vui lòng chọn cơ cấu tổ chức của bạn",
				ru: "Пожалуйста, выберите организационную структуру"
			},
			cdtm17: {
				zh: "分辨率",
				en: "Resolution",
				vi: "Độ phân giải",
				ru: "разрешение"
			},
			cdtm18: {
				zh: "请选择屏幕分辨率",
				en: "Please select screen resolution",
				vi: "Vui lòng chọn độ phân giải màn hình",
				ru: "Пожалуйста, выберите разрешение экрана"
			},
			cdtm19: {
				zh: "自定义",
				en: "customize",
				vi: "tùy chỉnh",
				ru: "настроить"
			},
			cdtm20: {
				zh: "设备类型",
				en: "Equipment type",
				vi: "Loại thiết bị",
				ru: "Тип устройства"
			},
			cdtm21: {
				zh: "请选择设备类型",
				en: "Please select device type",
				vi: "Vui lòng chọn loại thiết bị",
				ru: "Пожалуйста, выберите тип устройства"
			},
			cdtm22: {
				zh: "请输入SN",
				en: "Please enter SN",
				vi: "Vui lòng nhập SN",
				ru: "Пожалуйста, введите SN"
			},
			cdtm23: {
				zh: "位置",
				en: "Location",
				vi: "Vị trí",
				ru: "положение"
			},
			cdtm24: {
				zh: "密匙",
				en: "Key",
				vi: "Phím",
				ru: "ключ"
			},
			cdtm25: {
				zh: "备注1",
				en: "Note 1",
				vi: "Lưu ý 1",
				ru: "Замечания 1"
			},
			cdtm26: {
				zh: "取 消",
				en: "Cancel",
				vi: "Hủy bỏ",
				ru: "отменять"
			},
			cdtm27: {
				zh: "确 定",
				en: "Sure",
				vi: "Chắc chắn",
				ru: "определять"
			},
			cdtm28: {
				zh: "设备名称不能为空",
				en: "Device name cannot be empty",
				vi: "Tên thiết bị không được để trống",
				ru: "Имя устройства не может быть пустым"
			},
			cdtm29: {
				zh: "组织结构不能为空",
				en: "Organization structure cannot be empty",
				vi: "Cơ cấu tổ chức không được để trống",
				ru: "Организационная структура не может быть пустой"
			},
			cdtm30: {
				zh: "SN不能为空",
				en: "SN cannot be empty",
				vi: "SN không thể trống",
				ru: "SN не может быть пустым"
			},
			cdtm31: {
				zh: "屏幕分辨率不能为空",
				en: "Screen resolution cannot be empty",
				vi: "Độ phân giải màn hình không được để trống",
				ru: "Разрешение экрана не может быть пустым"
			},
			cdtm32: {
				zh: "分辨率W为空",
				en: "Resolution W is empty",
				vi: "Độ phân giải W trống",
				ru: "Разрешение W пустое"
			},
			cdtm33: {
				zh: "分辨率H为空",
				en: "Resolution H is empty",
				vi: "Độ phân giải H trống",
				ru: "Разрешение H пустое"
			},
			cdtm34: {
				zh: "位置X为空",
				en: "Position X is empty",
				vi: "Vị trí X trống",
				ru: "Позиция X пуста"
			},
			cdtm35: {
				zh: "位置Y为空",
				en: "Position Y is empty",
				vi: "Vị trí Y trống",
				ru: "Позиция Y пуста"
			}
		}
	},
	explorer: {
		NewMediaList: {
			FileItem: {
				cenf1: {
					zh: "文件名",
					en: "file name",
					vi: "tên tập tin",
					ru: "Имя файла"
				}
			},
			index: {
				ceni1: {
					zh: "新建文件夹",
					en: "new folder",
					vi: "thư mục mới",
					ru: "Создайте новую папку"
				},
				ceni2: {
					zh: "删除选中文件",
					en: "Delete selected files",
					vi: "Xóa các tập tin đã chọn",
					ru: "Удалить выбранный файл"
				},
				ceni3: {
					zh: "请选择目录",
					en: "Please select a directory",
					vi: "Vui lòng chọn một thư mục",
					ru: "Пожалуйста, выберите оглавление"
				},
				ceni4: {
					zh: "文件编辑",
					en: "File Editing",
					vi: "Chỉnh sửa tập tin",
					ru: "Редактирование файлов"
				},
				ceni5: {
					zh: "请输入内容",
					en: "Please enter content",
					vi: "Vui lòng nhập nội dung",
					ru: "Пожалуйста, введите содержание"
				},
				ceni6: {
					zh: "请输入文件夹名称",
					en: "Please enter a folder name",
					vi: "Vui lòng nhập tên thư mục",
					ru: "Пожалуйста, введите название папки"
				}
			},
			MediaList: {
				cenm1: {
					zh: "视频",
					en: "video",
					vi: "Video",
					ru: "видео"
				},
				cenm2: {
					zh: "图片",
					en: "picture",
					vi: "hình ảnh",
					ru: "картинка"
				},
				cenm3: {
					zh: "文本",
					en: "text",
					vi: "chữ",
					ru: "текст"
				},
				cenm4: {
					zh: "未定义类型",
					en: "Undefined Type",
					vi: "Loại không xác định",
					ru: "Тип не определен"
				}
			}
		},
		MediaList: {
			cem1: {
				zh: "名称",
				en: "name",
				vi: "tên",
				ru: "название"
			},
			cem2: {
				zh: "组织结构",
				en: "Organizational Structure",
				vi: "Cơ cấu tổ chức",
				ru: "структура"
			},
			cem3: {
				zh: "目录结构",
				en: "Directory Structure",
				vi: "Cấu trúc thư mục",
				ru: "Структура каталогов"
			},
			cem4: {
				zh: "类型",
				en: "type",
				vi: "Loại",
				ru: "тип"
			},
			cem5: {
				zh: "文件尺寸",
				en: "File size",
				vi: "Kích thước tập tin",
				ru: "Размер файла"
			},
			cem6: {
				zh: "上传时间",
				en: "Upload time",
				vi: "thời gian tải lên",
				ru: "Время загрузки"
			},
			cem7: {
				zh: "删除媒体",
				en: "Delete Media",
				vi: "Xóa phương tiện",
				ru: "Удаление носителя"
			},
			cem8: {
				zh: "请问是否要永久删除当前选中多媒体？",
				en: "Do you want to permanently delete the currently selected multimedia?",
				vi: "Bạn có muốn xóa vĩnh viễn đa phương tiện hiện được chọn không?",
				ru: "Вы хотите безвозвратно удалить выбранные в данный момент мультимедийные файлы?"
			},
			cem9: {
				zh: "文件筛选",
				en: "File Filtering",
				vi: "Lọc tệp",
				ru: "Фильтрация файлов"
			},
			cem10: {
				zh: "全选",
				en: "select all",
				vi: "chọn tất cả",
				ru: "Выбрать все"
			},
			cem11: {
				zh: "视频",
				en: "video",
				vi: "Video",
				ru: "видео"
			},
			cem12: {
				zh: "图片",
				en: "picture",
				vi: "hình ảnh",
				ru: "картинка"
			},
			cem13: {
				zh: "文本",
				en: "text",
				vi: "chữ",
				ru: "текст"
			},
			cem14: {
				zh: "未定义类型",
				en: "Undefined Type",
				vi: "Loại không xác định",
				ru: "Тип не определен"
			},
			cem15: {
				zh: "音乐",
				en: "music",
				vi: "âm nhạc",
				ru: "музыка"
			},
			cem16: {
				zh: "文件类型",
				en: "file type",
				vi: "loại tệp",
				ru: "Тип файла"
			},
			cem17: {
				zh: "文件尺寸",
				en: "File size",
				vi: "Kích thước tập tin",
				ru: "Размер файла"
			},
			cem18: {
				zh: "文件大小",
				en: "File size",
				vi: "Kích cỡ  tập tin",
				ru: "Размер файла"
			}
		},
		MediaUp: {
			cemu1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры"
			},
			cemu2: {
				zh: "上传",
				en: "Upload",
				vi: "Tải lên",
				ru: "загружать"
			},
			cemu3: {
				zh: "全部开始",
				en: "All Start",
				vi: "Tất cả bắt đầu",
				ru: "Все начинается"
			},
			cemu4: {
				zh: "全部停止",
				en: "Stop All",
				vi: "Tất cả dừng lại",
				ru: "Остановить все"
			},
			cemu5: {
				zh: "清空完成",
				en: "Clear completed",
				vi: "Hoàn thành xoá",
				ru: "Опорожнение завершено"
			},
			cemu6: {
				zh: "返回发布",
				en: "Back to Post",
				vi: "Quay lại bài viết",
				ru: "Вернуться к выпуску"
			},
			cemu7: {
				zh: "暂无上传文件",
				en: "No uploaded files yet",
				vi: "Chưa có tập tin nào được tải lên",
				ru: "Пока нет загруженных файлов"
			},
			cemu8: {
				zh: "文件名称",
				en: "file name",
				vi: "tên tập tin",
				ru: "Имя файла"
			},
			cemu9: {
				zh: "状态",
				en: "state",
				vi: "trạng thái",
				ru: "состояние"
			},
			cemu10: {
				zh: "操作",
				en: "operate",
				vi: "vận hành",
				ru: "работать"
			},
			cemu11: {
				zh: "请问是否要取消上传当前文件？",
				en: "Do you want to cancel uploading the current file?",
				vi: "Bạn có muốn hủy tải lên tập tin hiện tại không?",
				ru: "Вы хотите отменить загрузку текущего файла?"
			},
			cemu12: {
				zh: "上传完成",
				en: "upload completed",
				vi: "Hoàn tất tải lên",
				ru: "Загрузка завершена"
			},
			cemu13: {
				zh: "请选择上传文件!",
				en: "Please select upload file!",
				vi: "Vui lòng chọn file tải lên!",
				ru: "Пожалуйста, выберите загрузить файл!"
			},
			cemu14: {
				zh: "请选择上传目录!",
				en: "Please select the upload directory!",
				vi: "Vui lòng chọn thư mục tải lên!",
				ru: "Пожалуйста, выберите каталог для загрузки!"
			},
			cemu15: {
				zh: "上传失败或成功执行！",
				en: "Upload failed or executed successfully!",
				vi: "Tải lên không thành công hoặc thực hiện thành công!",
				ru: "Загрузка завершилась неудачей или была выполнена успешно!"
			},
			cemu16: {
				zh: "全部上传完成！",
				en: "All uploaded!",
				vi: "Tất cả đã được tải lên!",
				ru: "Все загрузки завершены!"
			},
			cemu17: {
				zh: "文件上传个数不可以大于20个!",
				en: "The number of files uploaded cannot exceed 20!",
				vi: "Số lượng tệp được tải lên không thể vượt quá 20!",
				ru: "Количество загруженных файлов не может превышать 20!"
			},
			cemu18: {
				zh: "确定移除",
				en: "Confirm removal",
				vi: "Xác nhận xóa",
				ru: "Подтвердите удаление"
			},
			cemu19: {
				zh: "当前目录无文件类型",
				en: "There is no file type in the current directory",
				vi: "Không có loại tập tin trong thư mục hiện tại",
				ru: "Текущий каталог не имеет типа файла"
			},
			cemu20: {
				zh: "视频",
				en: "video",
				vi: "Video",
				ru: "видео"
			},
			cemu21: {
				zh: "图片",
				en: "picture",
				vi: "hình ảnh",
				ru: "картинка"
			},
			cemu22: {
				zh: "音乐",
				en: "music",
				vi: "âm nhạc",
				ru: "музыка"
			}
		}
	},
	home: {
		index: {
			chi1: {
				zh: "消息",
				en: "information",
				vi: "thông tin",
				ru: "новость"
			},
			chi2: {
				zh: "系统消息",
				en: "system information",
				vi: "thông tin hệ thống",
				ru: "Системное сообщение"
			},
			chi3: {
				zh: "导出设备MAC列表",
				en: "Export device MAC list",
				vi: "Xuất danh sách MAC của thiết bị",
				ru: "Экспорт списка MAC устройств"
			},
			chi4: {
				zh: "拼命加载中",
				en: "Loading",
				vi: "Đang tải",
				ru: "Отчаянно загружаясь"
			},
			chi5: {
				zh: "播放统计",
				en: "Playback Statistics",
				vi: "Thống kê phát lại",
				ru: "Статистика"
			},
			chi6: {
				zh: "导出记录",
				en: "Export Records",
				vi: "Xuất bản ghi",
				ru: "Экспортная запись"
			},
			chi7: {
				zh: "素材统计",
				en: "Material Statistics",
				vi: "Thống kê vật liệu",
				ru: "Материал"
			},
			chi8: {
				zh: "节目统计",
				en: "Program Statistics",
				vi: "Thống kê chương trình",
				ru: "Программа"
			},
			chi9: {
				zh: "暂无数据",
				en: "No data",
				vi: "Không có dữ liệu",
				ru: "Нет доступных данных"
			},
			chi10: {
				zh: "输入名称搜索",
				en: "Enter name to search",
				vi: "Nhập tên để tìm kiếm",
				ru: "Введите имя для поиска"
			},
			chi11: {
				zh: "底线",
				en: "Bottom Line",
				vi: "Dòng dưới cùng",
				ru: "граница"
			},
			chi12: {
				zh: "导出",
				en: "Export",
				vi: "Xuất",
				ru: "экспорт"
			},
			chi13: {
				zh: "至",
				en: "to",
				vi: "ĐẾN",
				ru: "до"
			},
			chi14: {
				zh: "开始日期",
				en: "start date",
				vi: "ngày bắt đầu",
				ru: "Дата начала"
			},
			chi15: {
				zh: "结束日期",
				en: "End Date",
				vi: "Ngày cuối",
				ru: "Дата окончания"
			},
			chi16: {
				zh: "单次最多导出5万条。",
				en: "A maximum of 50,000 records can be exported at a time.",
				vi: "Có thể xuất tối đa 50.000 bản ghi cùng một lúc.",
				ru: "Экспортируйте до 50 000 товаров одновременно."
			},
			chi17: {
				zh: "欢迎使用Kares,让世界只有指尖的距离。Kares拥有完美的跨平台解决方案，其基于网络平台，采用分布式区域管理技术，可以有效整合各种多媒体资源，实现远程制作，发布和管理节目。",
				en: "Welcome to Kares, which makes the world just at your fingertips. Kares has a perfect cross-platform solution. It is based on a network platform and adopts distributed regional management technology. It can effectively integrate various multimedia resources and realize remote production, publishing and management of programs.",
				vi: "Chào mừng bạn đến với Kares, nơi khiến thế giới nằm trong tầm tay bạn. Kares có một giải pháp đa nền tảng hoàn hảo. Nó dựa trên nền tảng mạng và áp dụng công nghệ quản lý khu vực phân tán. Nó có thể tích hợp hiệu quả các tài nguyên đa phương tiện khác nhau và thực hiện việc sản xuất, xuất bản và quản lý chương trình từ xa.",
				ru: "Добро пожаловать в Kares, чтобы весь мир был на расстоянии вытянутой руки.Kares предлагает идеальное кроссплатформенное решение, основанное на сетевой платформе и использующее технологию распределенного регионального управления, которая позволяет эффективно интегрировать различные мультимедийные ресурсы и осуществлять удаленное производство, распространение и управление программами."
			},
			chi18: {
				zh: "添加素材",
				en: "Adding Materials",
				vi: "Thêm tài liệu",
				ru: "Добавить материал"
			},
			chi19: {
				zh: "批量上传，格式丰富，分类查找，海量素材快速定位",
				en: "Batch upload, rich formats, classified search, rapid location of massive materials",
				vi: "Tải lên hàng loạt, định dạng phong phú, tìm kiếm được phân loại, định vị nhanh chóng các tài liệu khổng lồ",
				ru: "Массовая загрузка, богатый формат"
			},
			chi20: {
				zh: "节目制作",
				en: "program production",
				vi: "sản xuất chương trình",
				ru: "Редактирование"
			},
			chi21: {
				zh: "拖拽式的操作，编排效果所见即所得，快速完成节目制作",
				en: "Drag-and-drop operation, what you see is what you get, quickly complete program production",
				vi: "Thao tác kéo và thả, những gì bạn thấy là những gì bạn nhận được, nhanh chóng hoàn thành việc sản xuất chương trình",
				ru: "Перетаскивание операций, быстрое завершение производства"
			},
			chi22: {
				zh: "节目发布",
				en: "Program Release",
				vi: "Xuất bản",
				ru: "Выпуск программы"
			},
			chi23: {
				zh: "循环、定时，插播多种播放模式，节目投放井然有序",
				en: "Multiple playback modes such as loop, timing, and insert play ensure that programs are delivered in an orderly manner",
				vi: "Nhiều chế độ phát lại như lặp lại, định giờ và phát chèn đảm bảo rằng các chương trình được phân phối một cách có trật tự",
				ru: "Цикл, таймер, интерполяция и другие режимы"
			},
			chi24: {
				zh: "终端控制",
				en: "Terminal Control",
				vi: "Kiểm soát",
				ru: "Контроль"
			},
			chi25: {
				zh: "远程控制终端，一键批量操作，一人管千屏得心应手",
				en: "Remote control terminal, one-key batch operation, one person manages thousands of screens easily",
				vi: "Thiết bị đầu cuối điều khiển từ xa, thao tác hàng loạt bằng một phím, một người quản lý hàng nghìn màn hình một cách dễ dàng",
				ru: "Дистанционное управление, пакетная работа одним кликом"
			},
			chi26: {
				zh: "当前系统存储空间已使用",
				en: "The current system storage space is used",
				vi: "Dung lượng lưu trữ hệ thống hiện tại đã được sử dụng",
				ru: "Используется текущее системное пространство для хранения"
			},
			chi27: {
				zh: "当前数据存储空间已使用",
				en: "The current data storage space is used",
				vi: "Không gian lưu trữ dữ liệu hiện tại được sử dụng",
				ru: "Используется текущее пространство для хранения данных"
			},
			chi28: {
				zh: "当前时间段无任何数据",
				en: "There is no data for the current time period",
				vi: "Không có dữ liệu cho khoảng thời gian hiện tại",
				ru: "Нет данных за текущий период времени"
			},
			chi29: {
				zh: "数据导出成功,正在下载中...",
				en: "Data exported successfully, downloading...",
				vi: "Đã xuất dữ liệu thành công, đang tải xuống...",
				ru: "Данные были успешно экспортированы и в настоящее время загружаются..."
			},
			chi30: {
				zh: "序号",
				en: "Serial number",
				vi: "Số seri",
				ru: "серийный номер"
			},
			chi31: {
				zh: "设备分类",
				en: "Equipment Classification",
				vi: "Phân loại thiết bị",
				ru: "Классификация оборудования"
			},
			chi32: {
				zh: "设称备名",
				en: "Device Name",
				vi: "Tên thiết bị",
				ru: "Установить альтернативное имя"
			},
			chi33: {
				zh: "设备SN",
				en: "Equipment SN",
				vi: "Thiết bị SN",
				ru: "Оборудование SN"
			},
			chi34: {
				zh: "节目名称",
				en: "Name of programme",
				vi: "Tên chương trình",
				ru: "Название программы"
			},
			chi35: {
				zh: "开始时间",
				en: "Starting time",
				vi: "Thời gian bắt đầu",
				ru: "Время начала"
			},
			chi36: {
				zh: "结束时间",
				en: "End Time",
				vi: "Thời gian kết thúc",
				ru: "Время окончания"
			},
			chi37: {
				zh: "播放时间",
				en: "play time",
				vi: "Thời gian phát",
				ru: "Время игры"
			},
			chi38: {
				zh: "节目播放记录",
				en: "Program playback record",
				vi: "Bản ghi phát lại chương trình",
				ru: "Запись воспроизведения программы"
			},
			chi39: {
				zh: "素材播放记录",
				en: "Material playback record",
				vi: "Bản ghi phát lại tài liệu",
				ru: "Запись воспроизведения материала"
			},
			chi40: {
				zh: "播放记录列表_",
				en: "Playback record list_",
				vi: "Danh sách bản ghi phát lại_",
				ru: "Воспроизведение списка записей_"
			},
			chi41: {
				zh: "在线/离线",
				en: "Online/Offline",
				vi: "Online/Offline",
				ru: "Онлайн/оффлайн"
			},
			chi42: {
				zh: "分辨率图表",
				en: "Resolution chart",
				vi: "Biểu đồ độ phân giải",
				ru: "Диаграмма разрешения"
			},
			chi43: {
				zh: "设备分辨率",
				en: "Device resolution",
				vi: "Độ phân giải thiết bị",
				ru: "Разрешение устройства"
			},
			chi44: {
				zh: "素材统计",
				en: "Material Statistics",
				vi: "Thống kê cảnh quay",
				ru: "Существенная статистика"
			},
			chi45: {
				zh: "图片",
				en: "picture",
				vi: "hình ảnh",
				ru: "картинка"
			},
			chi46: {
				zh: "视频",
				en: "video",
				vi: "băng hình",
				ru: "видео"
			},
			chi47: {
				zh: "素材数量",
				en: "Number of materials",
				vi: "Số lượng vật liệu",
				ru: "Количество материала"
			},
			chi48: {
				zh: "素材类型",
				en: "Material Type",
				vi: "Loại vật liệu",
				ru: "Тип материала"
			},
			chi49: {
				zh: "素材存储",
				en: "Material storage",
				vi: "Lưu trữ tài liệu",
				ru: "Хранение материалов"
			},
			chi50: {
				zh: "素材计价",
				en: "price",
				vi: "JiJia",
				ru: "Стоимость"
			}
		}
	},
	log: {
		children: {
			DeviceList: {
				clcd1: {
					zh: "请选择",
					en: "please choose",
					vi: "xin vui lòng chọn",
					ru: "Пожалуйста выберите"
				}
			},
			ExportDialog: {
				clce1: {
					zh: "设备名称",
					en: "Device Name",
					vi: "Tên thiết bị",
					ru: "Имя устройства"
				},
				clce2: {
					zh: "设备SN",
					en: "Equipment SN",
					vi: "Thiết bị SN",
					ru: "Оборудование SN"
				},
				clce3: {
					zh: "组织结构",
					en: "Organizational Structure",
					vi: "Cơ cấu tổ chức",
					ru: "структура"
				},
				clce4: {
					zh: "类型",
					en: "type",
					vi: "Loại",
					ru: "тип"
				},
				clce5: {
					zh: "操作时间",
					en: "Operation time",
					vi: "Thời gian hoạt động",
					ru: "Время работы"
				},
				clce6: {
					zh: "操作用户",
					en: "Operation User",
					vi: "Người dùng thao tác",
					ru: "Действующий пользователь"
				},
				clce7: {
					zh: "功能",
					en: "Function",
					vi: "Chức năng",
					ru: "функция"
				},
				clce8: {
					zh: "描述",
					en: "describe",
					vi: "mô tả",
					ru: "описание"
				},
				clce9: {
					zh: "编号",
					en: "serial number",
					vi: "số seri",
					ru: "серийный номер"
				},
				clce10: {
					zh: "内容",
					en: "content",
					vi: "nội dung",
					ru: "содержание"
				},
				clce11: {
					zh: "操作对象",
					en: "Operation Object",
					vi: "Đối tượng hoạt động",
					ru: "Объект операции"
				},
				clce12: {
					zh: "操作信息",
					en: "Operational Information",
					vi: "Thông tin hoạt động",
					ru: "Информация о работе"
				},
				clce13: {
					zh: "操作日志_",
					en: "Operation Log_",
					vi: "Nhật ký hoạt động_",
					ru: "Журнал операций_"
				},
				clce14: {
					zh: "终端日志_",
					en: "Terminal Log_",
					vi: "Nhật ký thiết bị đầu cuối_",
					ru: "Журнал регистрации терминала_"
				}
			}
		},
		LoginLog: {
			cll1: {
				zh: "范围查询",
				en: "Range Query",
				vi: "Truy vấn phạm vi",
				ru: "Запрос области действия"
			},
			cll2: {
				zh: "至",
				en: "to",
				vi: "ĐẾN",
				ru: "до"
			},
			cll3: {
				zh: "开始日期",
				en: "start date",
				vi: "ngày bắt đầu",
				ru: "Дата начала"
			},
			cll4: {
				zh: "结束日期",
				en: "End Date",
				vi: "Ngày cuối",
				ru: "Дата окончания"
			},
			cll5: {
				zh: "最近一周",
				en: "Last week",
				vi: "Tuần trước",
				ru: "Прошлая неделя"
			},
			cll6: {
				zh: "最近一个月",
				en: "Last month",
				vi: "Tháng trước",
				ru: "Прошлый месяц"
			},
			cll7: {
				zh: "最近三个月",
				en: "Last three months",
				vi: "Ba tháng qua",
				ru: "Последние три месяца"
			},
			cll8: {
				zh: "确定...",
				en: "Sure...",
				vi: "Chắc chắn...",
				ru: "уверенный..."
			},
			cll9: {
				zh: "导出.....",
				en: "Export...",
				vi: "Xuất",
				ru: "экспорт....."
			}
		},
		OperationLog: {
			clo1: {
				zh: "范围查询",
				en: "Range Query",
				vi: "Truy vấn phạm vi",
				ru: "Запрос области действия"
			},
			clo2: {
				zh: "至",
				en: "to",
				vi: "ĐẾN",
				ru: "до"
			},
			clo3: {
				zh: "开始日期",
				en: "start date",
				vi: "ngày bắt đầu",
				ru: "Дата начала"
			},
			clo4: {
				zh: "结束日期",
				en: "End Date",
				vi: "Ngày cuối",
				ru: "Дата окончания"
			},
			clo5: {
				zh: "最近一周",
				en: "Last week",
				vi: "Tuần trước",
				ru: "Прошлая неделя"
			},
			clo6: {
				zh: "最近一个月",
				en: "Last month",
				vi: "Tháng trước",
				ru: "Прошлый месяц"
			},
			clo7: {
				zh: "最近三个月",
				en: "Last three months",
				vi: "Ba tháng qua",
				ru: "Последние три месяца"
			}
		},
		TerminalLog: {
			clt1: {
				zh: "编号查询",
				en: "Number query",
				vi: "Truy vấn số",
				ru: "Числовой запрос"
			},
			clt2: {
				zh: "未查询到",
				en: "Not found",
				vi: "Không tìm thấy",
				ru: "Не запрашивался"
			}
		}
	},
	login: {
		Register: {
			clr1: {
				zh: "用户注册",
				en: "User Registration",
				vi: "Đăng ký người dùng",
				ru: "Регистрация пользователя"
			},
			clr2: {
				zh: "账号",
				en: "account",
				vi: "tài khoản",
				ru: "счет"
			},
			clr3: {
				zh: "推荐码",
				en: "Referral Code",
				vi: "Mã giới thiệu",
				ru: "Рекомендательный код"
			},
			clr4: {
				zh: "获取推荐码请联系销售人员！",
				en: "Please contact sales to get the referral code!",
				vi: "Vui lòng liên hệ bộ phận bán hàng để nhận mã giới thiệu!",
				ru: "Пожалуйста, свяжитесь с отделом продаж, чтобы получить рекомендательный код!"
			},
			clr5: {
				zh: "邮箱",
				en: "Mail",
				vi: "Thư",
				ru: "электронная почта"
			},
			clr6: {
				zh: "验证码",
				en: "Verification Code",
				vi: "Mã xác nhận",
				ru: "Код подтверждения"
			},
			clr7: {
				zh: "获取验证码",
				en: "get verification code",
				vi: "lấy mã xác minh",
				ru: "Получить проверочный код"
			},
			clr8: {
				zh: "秒重新获取",
				en: "Re-acquire in seconds",
				vi: "Lấy lại sau vài giây",
				ru: "Восстановиться за считанные секунды"
			},
			clr9: {
				zh: "密码",
				en: "password",
				vi: "mật khẩu",
				ru: "код"
			},
			clr10: {
				zh: "确认密码",
				en: "Confirm Password",
				vi: "Xác nhận mật khẩu",
				ru: "Подтвердите пароль"
			},
			clr11: {
				zh: "分组",
				en: "Grouping",
				vi: "Nhóm",
				ru: "разделиться на группы"
			},
			clr12: {
				zh: "立即注册",
				en: "Sign up now",
				vi: "Đăng ký ngay",
				ru: "Зарегистрируйтесь прямо сейчас"
			},
			clr13: {
				zh: "已有帐号",
				en: "Already have an account",
				vi: "Bạn đã có tài khoản",
				ru: "У вас уже есть учетная запись"
			},
			clr14: {
				zh: "立即登录",
				en: "log in immediately",
				vi: "đăng nhập ngay lập tức",
				ru: "Войдите в систему прямо сейчас"
			},
			clr15: {
				zh: "请再次输入密码",
				en: "Please enter your password again",
				vi: "Vui lòng nhập lại mật khẩu của bạn",
				ru: "Пожалуйста, введите пароль еще раз"
			},
			clr16: {
				zh: "两次输入密码不一致!",
				en: "The passwords you entered twice do not match!",
				vi: "Mật khẩu bạn nhập hai lần không khớp!",
				ru: "Введенный дважды пароль является несогласованным!"
			},
			clr17: {
				zh: "请输入用户名！",
				en: "please enter user name!",
				vi: "Vui lòng nhập tên người dùng!",
				ru: "Пожалуйста, введите имя пользователя!"
			},
			clr18: {
				zh: "请填写推荐码",
				en: "Please fill in the referral code",
				vi: "Vui lòng điền mã giới thiệu",
				ru: "Пожалуйста, введите рекомендательный код"
			},
			clr19: {
				zh: "请填写验证码",
				en: "Please fill in the verification code",
				vi: "Vui lòng điền mã xác minh",
				ru: "Пожалуйста, введите проверочный код"
			},
			clr20: {
				zh: "请填写邮箱",
				en: "please enter your email",
				vi: "Vui lòng nhập email",
				ru: "Пожалуйста, введите адрес электронной почты"
			},
			clr21: {
				zh: "请填写密码",
				en: "Please fill in the password",
				vi: "Vui lòng điền mật khẩu",
				ru: "Пожалуйста, введите пароль"
			},
			clr22: {
				zh: "请填写用户分组",
				en: "Please fill in the user group",
				vi: "Vui lòng điền vào nhóm người dùng",
				ru: "Пожалуйста, заполните группу пользователей"
			},
			clr23: {
				zh: "验证码已发送，请注意查收!",
				en: "The verification code has been sent, please check it!",
				vi: "Mã xác minh đã được gửi, vui lòng kiểm tra!",
				ru: "Проверочный код был отправлен, пожалуйста, обратите внимание на его проверку!"
			}
		},
		ResetPd: {
			clrp1: {
				zh: "重置密码",
				en: "reset Password",
				vi: "đặt lại mật khẩu",
				ru: "Сброс пароля"
			},
			clrp2: {
				zh: "身份验证",
				en: "Authentication",
				vi: "Xác thực",
				ru: "Идентификация"
			},
			clrp3: {
				zh: "重置密码",
				en: "reset Password",
				vi: "đặt lại mật khẩu",
				ru: "Сброс пароля"
			},
			clrp4: {
				zh: "账号",
				en: "account",
				vi: "tài khoản",
				ru: "счет"
			},
			clrp5: {
				zh: "邮箱",
				en: "Mail",
				vi: "Thư",
				ru: "электронная почта"
			},
			clrp6: {
				zh: "验证码",
				en: "Verification Code",
				vi: "Mã xác nhận",
				ru: "Код подтверждения"
			},
			clrp7: {
				zh: "获取验证码",
				en: "get verification code",
				vi: "lấy mã xác minh",
				ru: "Получить проверочный код"
			},
			clrp8: {
				zh: "秒重新获取",
				en: "Re-acquire in seconds",
				vi: "Lấy lại sau vài giây",
				ru: "Восстановиться за считанные секунды"
			},
			clrp9: {
				zh: "新密码",
				en: "New Password",
				vi: "mật khẩu mới",
				ru: "Новый пароль"
			},
			clrp10: {
				zh: "确认密码",
				en: "Confirm Password",
				vi: "Xác nhận mật khẩu",
				ru: "Подтвердите пароль"
			},
			clrp11: {
				zh: "立即验证",
				en: "confirm at once",
				vi: "xác nhận ngay lập tức",
				ru: "Проверить сейчас"
			},
			clrp12: {
				zh: "已有帐号",
				en: "Already have an account",
				vi: "Bạn co săn san để tạo một tai khoản",
				ru: "У вас уже есть учетная запись"
			},
			clrp13: {
				zh: "立即登录",
				en: "log in immediately",
				vi: "đăng nhập ngay lập tức",
				ru: "Войдите в систему прямо сейчас"
			},
			clrp14: {
				zh: "请再次输入密码",
				en: "Please enter your password again",
				vi: "Vui lòng nhập lại mật khẩu của bạn",
				ru: "Пожалуйста, введите пароль еще раз"
			},
			clrp15: {
				zh: "两次输入密码不一致!",
				en: "The passwords you entered twice do not match!",
				vi: "Mật khẩu bạn nhập hai lần không khớp!",
				ru: "Введенный дважды пароль является несогласованным!"
			},
			clrp16: {
				zh: "请输入用户名！",
				en: "please enter user name!",
				vi: "Vui lòng nhập tên người dùng!",
				ru: "Пожалуйста, введите имя пользователя!"
			},
			clrp17: {
				zh: "请填写邮箱",
				en: "please enter your email",
				vi: "Vui lòng nhập email",
				ru: "Пожалуйста, введите адрес электронной почты"
			},
			clrp18: {
				zh: "请填写验证码",
				en: "Please fill in the verification code",
				vi: "Vui lòng điền mã xác minh",
				ru: "Пожалуйста, введите проверочный код"
			},
			clrp19: {
				zh: "请填写密码",
				en: "Please fill in the password",
				vi: "Vui lòng điền mật khẩu",
				ru: "Пожалуйста, введите пароль"
			},
			clrp20: {
				zh: "验证码已发送，请注意查收!",
				en: "The verification code has been sent, please check it!",
				vi: "Mã xác minh đã được gửi, vui lòng kiểm tra!",
				ru: "Проверочный код был отправлен, пожалуйста, обратите внимание на его проверку!"
			}
		}
	},
	manage: {
		ReviewSetting: {
			cmr1: {
				zh: "组织结构",
				en: "Organizational Structure",
				vi: "Cơ cấu tổ chức",
				ru: "структура"
			},
			cmr2: {
				zh: "素材审核",
				en: "Material review",
				vi: "Đánh giá tài liệu",
				ru: "Обзор материалов"
			},
			cmr3: {
				zh: "清空",
				en: "Clear",
				vi: "Trống",
				ru: "очищать"
			},
			cmr4: {
				zh: "节目审核",
				en: "Program Review",
				vi: "Đánh giá chương trình",
				ru: "Обзор программы"
			},
			cmr5: {
				zh: "发布审核",
				en: "Release Review",
				vi: "Đánh giá phát hành",
				ru: "Обзор выпуска"
			},
			cmr6: {
				zh: "允许插播审核",
				en: "Allow interstitial review",
				vi: "Cho phép xem xét xen kẽ",
				ru: "Разрешить промежуточный обзор"
			},
			cmr7: {
				zh: "张三,李四,王五",
				en: "Zhang San, Li Si, Wang Wu",
				vi: "Trương Tam, Lý Tư, Vương Ngũ",
				ru: "Чжан Сань, Ли Си, Ван Ву"
			},
			cmr8: {
				zh: "是否清空当前所有审核人员?",
				en: "Do you want to clear all current reviewers?",
				vi: "Bạn có muốn xóa tất cả những người đánh giá hiện tại không?",
				ru: "Вы удаляете всех текущих аудиторов?"
			},
			cmr9: {
				zh: "是否清空当前审核人员?",
				en: "Do you want to clear the current reviewer?",
				vi: "Bạn có muốn xóa người đánh giá hiện tại không?",
				ru: "Допущен ли нынешний аудитор к работе?"
			},
			cmr10: {
				zh: "无相关审核权限的人员,请先创建审核账号",
				en: "If you do not have the relevant audit authority, please create an audit account first.",
				vi: "Nếu bạn không có cơ quan kiểm toán liên quan, trước tiên hãy tạo một tài khoản kiểm toán.",
				ru: "Для тех, у кого нет соответствующих аудиторских полномочий, пожалуйста, сначала создайте учетную запись аудитора"
			},
			cmr11: {
				zh: "下一机构共用同一审核人员",
				en: "Share the same reviewer with the next institution",
				vi: "Chia sẻ cùng một người đánh giá với tổ chức tiếp theo",
				ru: "В следующей организации используется тот же самый аудитор"
			},
			cmr12: {
				zh: "取消",
				en: "Cancel",
				vi: "Hủy bỏ",
				ru: "отменять"
			},
			cmr13: {
				zh: "确定",
				en: "Sure",
				vi: "Chắc chắn",
				ru: "уверенный"
			}
		}
	},
	review: {
		children: {
			ProgramMaterial: {
				crcp1: {
					zh: "视频",
					en: "video",
					vi: "băng hình",
					ru: "видео"
				},
				crcp2: {
					zh: "图片",
					en: "picture",
					vi: "hình ảnh",
					ru: "картинка"
				}
			},
			PublichCheck: {
				crcpc1: {
					zh: "播放时间轴",
					en: "Playback timeline",
					vi: "Dòng thời gian phát lại",
					ru: "Временная шкала воспроизведения"
				},
				crcpc2: {
					zh: "节目预览",
					en: "Program Preview",
					vi: "Xem trước chương trình",
					ru: "Предварительный просмотр программы"
				},
				crcpc3: {
					zh: "发布审核",
					en: "Release Review",
					vi: "Đánh giá phát hành",
					ru: "Обзор выпуска"
				},
				crcpc4: {
					zh: "原因",
					en: "reason",
					vi: "lý do",
					ru: "соображение"
				}
			}
		},
		CheckManage: {
			crc1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры"
			}
		},
		IssueCheck: {
			crl1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры"
			},
			crl2: {
				zh: "删除",
				en: "delete",
				vi: "xóa bỏ",
				ru: "стирать"
			},
			crl3: {
				zh: "确定删除当前选中审核条目",
				en: "Confirm to delete the currently selected audit entry",
				vi: "Xác nhận xóa mục kiểm tra hiện được chọn",
				ru: "Убедитесь в том, что вы удалили текущую выбранную запись аудита"
			},
			crl4: {
				zh: "未审核不能删除",
				en: "Unreviewed and cannot be deleted",
				vi: "Chưa được xem xét và không thể xóa được",
				ru: "Неаудированные данные не могут быть удалены"
			},
			crl5: {
				zh: "删除成功",
				en: "successfully deleted",
				vi: "đã xóa thành công",
				ru: "Успешно удален"
			},
			crl6: {
				zh: "请至少选择一条记录",
				en: "Please select at least one record",
				vi: "Vui lòng chọn ít nhất một bản ghi",
				ru: "Пожалуйста, выберите хотя бы одну запись"
			},
			crl7: {
				zh: "刷新",
				en: "refresh",
				vi: "Làm mới",
				ru: "обновлять"
			},
			crl8: {
				zh: "原因",
				en: "reason",
				vi: "lý do",
				ru: "соображение"
			}
		},
		MaterialCheck: {
			crm1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры"
			},
			crm2: {
				zh: "删除",
				en: "delete",
				vi: "xóa bỏ",
				ru: "стирать"
			},
			crm3: {
				zh: "确定删除当前选中审核条目",
				en: "Confirm to delete the currently selected audit entry",
				vi: "Xác nhận xóa mục kiểm tra hiện được chọn",
				ru: "Убедитесь в том, что вы удалили текущую выбранную запись аудита"
			},
			crm4: {
				zh: "未审核不能删除",
				en: "Unreviewed and cannot be deleted",
				vi: "Chưa được xem xét và không thể xóa được",
				ru: "Неаудированные данные не могут быть удалены"
			},
			crm5: {
				zh: "删除成功",
				en: "successfully deleted",
				vi: "đã xóa thành công",
				ru: "Успешно удален"
			},
			crm6: {
				zh: "选择的数据",
				en: "Selected Data",
				vi: "Dữ liệu đã chọn",
				ru: "Выбранные данные"
			}
		},
		ProgramCheck: {
			crp1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры"
			},
			crp2: {
				zh: "批量审核选中节目",
				en: "Batch review of selected programs",
				vi: "Đánh giá hàng loạt các chương trình đã chọn",
				ru: "Пакетный просмотр выбранных программ"
			},
			crp3: {
				zh: "确定删除当前选中审核条目",
				en: "Confirm to delete the currently selected audit entry",
				vi: "Xác nhận xóa mục kiểm tra hiện được chọn",
				ru: "Убедитесь в том, что вы удалили текущую выбранную запись аудита"
			},
			crp4: {
				zh: "未选择节目",
				en: "No program selected",
				vi: "Không có chương trình nào được chọn",
				ru: "Невыбранная программа"
			},
			crp5: {
				zh: "未审核不能删除",
				en: "Unreviewed and cannot be deleted",
				vi: "Chưa được xem xét và không thể xóa được",
				ru: "Неаудированные данные не могут быть удалены"
			},
			crp6: {
				zh: "删除成功",
				en: "successfully deleted",
				vi: "đã xóa thành công",
				ru: "Успешно удален"
			}
		}
	},
	schedule: {
		children: {
			items: {
				TimePlanItems: {
					cscit1: {
						zh: "总播放次数",
						en: "Total playback times",
						vi: "Tổng số lần phát lại",
						ru: "Общее количество воспроизведений"
					},
					cscit2: {
						zh: "开始日期是",
						en: "Start date is",
						vi: "Ngày bắt đầu là",
						ru: "Датой начала является"
					},
					cscit3: {
						zh: "选择的开始日期不能早于今天",
						en: "Select a start date that cannot be earlier than today",
						vi: "Chọn ngày bắt đầu không thể sớm hơn ngày hôm nay",
						ru: "Выбранная дата начала не может быть ранее сегодняшнего дня"
					},
					cscit4: {
						zh: "触发",
						en: "trigger",
						vi: "Kích hoạt",
						ru: "инициировать"
					}
				},
				TimerShaft: {
					cscits1: {
						zh: "排程时间",
						en: "Schedule time",
						vi: "Thời gian biểu",
						ru: "Запланируйте время"
					},
					cscits2: {
						zh: "选择日期",
						en: "Select Date",
						vi: "Chọn ngày",
						ru: "Выберите дату"
					}
				}
			},
			AddSchedule: {
				csca1: {
					zh: "点击或向上滑动继续加载",
					en: "Click or swipe up to continue loading",
					vi: "Nhấp hoặc vuốt lên để tiếp tục tải",
					ru: "Нажмите или проведите пальцем вверх, чтобы продолжить загрузку"
				},
				csca2: {
					zh: "向下滑动继续加载",
					en: "Swipe down to continue loading",
					vi: "Vuốt xuống để tiếp tục tải",
					ru: "Проведите пальцем вниз, чтобы продолжить загрузку"
				},
				csca3: {
					zh: "已加载全部资源",
					en: "All resources loaded",
					vi: "Đã tải tất cả tài nguyên",
					ru: "Все ресурсы были загружены"
				},
				csca4: {
					zh: "关联设备",
					en: "Related equipment",
					vi: "Thiết bị liên quan",
					ru: "Сопутствующее оборудование"
				},
				csca5: {
					zh: "请选择关联设备",
					en: "Please select the associated device",
					vi: "Vui lòng chọn thiết bị được liên kết",
					ru: "Пожалуйста, выберите соответствующее устройство"
				},
				csca6: {
					zh: "添加关联设备",
					en: "Add associated device",
					vi: "Thêm thiết bị liên quan",
					ru: "Добавление связанных устройств"
				},
				csca7: {
					zh: "请选择播放模式",
					en: "Please select the playback mode",
					vi: "Vui lòng chọn chế độ phát lại",
					ru: "Пожалуйста, выберите режим воспроизведения"
				},
				csca8: {
					zh: "新增排程",
					en: "Add Schedule",
					vi: "Thêm lịch trình",
					ru: "Новое расписание"
				},
				csca9: {
					zh: "取消",
					en: "Cancel",
					vi: "Hủy bỏ",
					ru: "отменять"
				},
				csca10: {
					zh: "保存",
					en: "save",
					vi: "cứu",
					ru: "сохранить"
				},
				csca11: {
					zh: "提交",
					en: "submit",
					vi: "nộp",
					ru: "передавать"
				},
				csca12: {
					zh: "选择发布终端",
					en: "Select the publishing terminal",
					vi: "Chọn thiết bị đầu cuối đã phát hành",
					ru: "Выберите терминал публикации"
				},
				csca13: {
					zh: "请输入查询终端",
					en: "Please enter the query terminal",
					vi: "Vui lòng nhập thiết bị đầu cuối truy vấn",
					ru: "Пожалуйста, войдите в терминал запроса"
				},
				csca14: {
					zh: "终端名称",
					en: "Terminal Name",
					vi: "Tên thiết bị đầu cuối",
					ru: "Название терминала"
				},
				csca15: {
					zh: "组织结构",
					en: "Organizational Structure",
					vi: "Cơ cấu tổ chức",
					ru: "структура"
				},
				csca16: {
					zh: "设备类型",
					en: "Equipment type",
					vi: "Loại thiết bị",
					ru: "Тип устройства"
				},
				csca17: {
					zh: "设备状态",
					en: "device status",
					vi: "trạng thái thiết bị",
					ru: "Состояние устройства"
				},
				csca18: {
					zh: "离线",
					en: "Offline",
					vi: "Ngoại tuyến",
					ru: "не в сети"
				},
				csca19: {
					zh: "分辨率",
					en: "Resolution",
					vi: "Độ phân giiải",
					ru: "разрешение"
				},
				csca20: {
					zh: "文件筛选",
					en: "File Filtering",
					vi: "Lọc tệp",
					ru: "Фильтрация файлов"
				},
				csca21: {
					zh: "循环播放",
					en: "Loop",
					vi: "Vòng lặp",
					ru: "Воспроизведение в цикле"
				},
				csca22: {
					zh: "视频",
					en: "video",
					vi: "băng hình",
					ru: "видео"
				},
				csca23: {
					zh: "图片",
					en: "picture",
					vi: "hình ảnh",
					ru: "картинка"
				},
				csca24: {
					zh: "音乐",
					en: "music",
					vi: "âm nhạc",
					ru: "музыка"
				},
				csca25: {
					zh: "文本",
					en: "text",
					vi: "chữ",
					ru: "текст"
				},
				csca26: {
					zh: "文件类型",
					en: "file type",
					vi: "loại tệp",
					ru: "Тип файла"
				},
				csca27: {
					zh: "文件尺寸",
					en: "File size",
					vi: "Kích thước tập tin",
					ru: "Размер файла"
				},
				csca28: {
					zh: "文件大小",
					en: "File size",
					vi: "Kích thước tập tin",
					ru: "Размер файла"
				},
				csca29: {
					zh: "未选择任何关联设备!",
					en: "No associated device selected!",
					vi: "Không có thiết bị liên quan nào được chọn!",
					ru: "Ни одно связанное устройство не выбрано!"
				},
				csca30: {
					zh: "未选择任何节目!",
					en: "No show selected!",
					vi: "Không có chương trình nào được chọn!",
					ru: "Программа не выбрана!"
				},
				csca31: {
					zh: "未添加任何排程!",
					en: "No schedule added!",
					vi: "Không có lịch trình được thêm vào!",
					ru: "Расписание не было добавлено!"
				},
				csca32: {
					zh: "第条排程设置结束时间为历史时间,不可播放!",
					en: "The end time of the schedule is set to historical time and cannot be played!",
					vi: "Thời gian kết thúc lịch thi đấu được thiết lập theo thời gian lịch sử và không thể chơi được!",
					ru: "Статья 1 Время окончания настройки расписания является историческим и не может быть воспроизведено!"
				},
				csca33: {
					zh: "第条排程设置开始时间大于结束时间!",
					en: "The start time of scheduling is greater than the end time!",
					vi: "Lịch trình đầu tiên đặt thời gian bắt đầu lớn hơn thời gian kết thúc!",
					ru: "Статья 1 Время начала настройки расписания больше, чем время окончания!"
				},
				csca34: {
					zh: "排程添加成功后自动跳转到播放日程列表",
					en: "After the schedule is added successfully, it will automatically jump to the play schedule list",
					vi: "Sau khi lịch trình được thêm thành công, nó sẽ tự động chuyển sang danh sách lịch phát",
					ru: "Автоматический переход к списку расписаний воспроизведения после успешного добавления расписания"
				}
			},
			DelDialog: {
				cscd1: {
					zh: "标 题",
					en: "Title",
					vi: "Tiêu đề",
					ru: "Заглавие"
				}
			},
			EditPlan: {
				csce1: {
					zh: "选择模板",
					en: "Select a template",
					vi: "Chọn một mẫu",
					ru: "Выберите шаблон"
				},
				csce2: {
					zh: "存为模板",
					en: "Save as Template",
					vi: "Lưu dưới dạng mẫu",
					ru: "Сохранить как шаблон"
				},
				csce3: {
					zh: "导入模板",
					en: "Importing a template",
					vi: "Nhập mẫu",
					ru: "Импорт шаблона"
				},
				csce4: {
					zh: "导出模板",
					en: "Export Template",
					vi: "Xuất mẫu",
					ru: "Шаблон для экспорта"
				},
				csce5: {
					zh: "请输入模板名称",
					en: "Please enter a template name",
					vi: "Vui lòng nhập tên mẫu",
					ru: "Пожалуйста, введите название шаблона"
				},
				csce6: {
					zh: "取消",
					en: "Cancel",
					vi: "Hủy bỏ",
					ru: "отменять"
				},
				csce7: {
					zh: "确定",
					en: "Sure",
					vi: "Chắc chắn",
					ru: "уверенный"
				},
				csce8: {
					zh: "节目id",
					en: "Program ID",
					vi: "Mã chương trình",
					ru: "Идентификатор программы"
				},
				csce9: {
					zh: "节目名称",
					en: "Name of programme",
					vi: "Tên chương trình",
					ru: "Название программы"
				},
				csce10: {
					zh: "开始时间",
					en: "Starting time",
					vi: "Thời gian bắt đầu",
					ru: "Время начала"
				},
				csce11: {
					zh: "结束时间",
					en: "End Time",
					vi: "Thời gian kết thúc",
					ru: "Время окончания"
				},
				csce12: {
					zh: "有效日期",
					en: "Effective Date",
					vi: "Ngày có hiệu lực",
					ru: "Дата вступления в силу"
				},
				csce13: {
					zh: "开始日期",
					en: "start date",
					vi: "ngày bắt đầu",
					ru: "Дата начала"
				},
				csce14: {
					zh: "结束日期",
					en: "End Date",
					vi: "Ngày cuối",
					ru: "Дата окончания"
				},
				csce15: {
					zh: "有效星期",
					en: "Valid week",
					vi: "Tuần hợp lệ",
					ru: "Эффективная неделя"
				},
				csce16: {
					zh: "星期",
					en: "Week",
					vi: "Tuần",
					ru: "неделя"
				},
				csce17: {
					zh: "连续循环次数",
					en: "Continuous cycles",
					vi: "Chu kỳ liên tục",
					ru: "Количество последовательных циклов"
				},
				csce18: {
					zh: "总播放次数",
					en: "Total playback times",
					vi: "Tổng số lần phát lại",
					ru: "Общее количество воспроизведений"
				},
				csce19: {
					zh: "删除成功",
					en: "successfully deleted",
					vi: "đã xóa thành công",
					ru: "Успешно удален"
				},
				csce20: {
					zh: "删除失败",
					en: "failed to delete",
					vi: "không thể xóa",
					ru: "Не удалось удалить файл"
				},
				csce21: {
					zh: "有效",
					en: "efficient",
					vi: "có hiệu quả",
					ru: "эффективный"
				},
				csce22: {
					zh: "排程不能为空！",
					en: "Schedule cannot be empty!",
					vi: "Lịch trình không thể trống!",
					ru: "Расписание не может быть пустым!"
				},
				csce23: {
					zh: "无效",
					en: "invalid",
					vi: "không hợp lệ",
					ru: "недействительный"
				},
				csce24: {
					zh: "定时播放_",
					en: "Timed playback_",
					vi: "Hẹn giờ phát lại",
					ru: "Синхронизированное воспроизведение_"
				},
				csce25: {
					zh: "定时播放模板导出成功！",
					en: "The timed playback template was exported successfully!",
					vi: "Mẫu phát lại hẹn giờ đã được xuất thành công!",
					ru: "Шаблон синхронизированного воспроизведения был успешно экспортирован!"
				},
				csce26: {
					zh: "保存成功",
					en: "Saved successfully",
					vi: "đã lưu thành công",
					ru: "Успешно сохранен"
				}
			},
			GetDeviceDialog: {
				cscg1: {
					zh: "发布—选择终端",
					en: "Publish—Select Target",
					vi: "Xuất bản—Chọn mục tiêu",
					ru: "Терминал для выбора публикации"
				},
				cscg2: {
					zh: "组织结构分组",
					en: "Organizational Structure Grouping",
					vi: "Nhóm cơ cấu tổ chức",
					ru: "Группировка организационной структуры"
				},
				cscg3: {
					zh: "请输入设备名",
					en: "Please enter the device name",
					vi: "Vui lòng nhập tên thiết bị",
					ru: "Пожалуйста, введите название устройства"
				},
				cscg4: {
					zh: "确定",
					en: "Sure",
					vi: "Chắc chắn",
					ru: "уверенный"
				},
				cscg5: {
					zh: "取消",
					en: "Cancel",
					vi: "Hủy bỏ",
					ru: "отменять"
				},
				cscg6: {
					zh: "自动适配屏幕大小播放",
					en: "Automatically adapt to screen size for playback",
					vi: "Tự động thích ứng với kích thước màn hình để phát lại",
					ru: "Автоматическая адаптация к размеру экрана для воспроизведения"
				},
				cscg7: {
					zh: "发布类型",
					en: "Release Type",
					vi: "Loại phát hành",
					ru: "Тип выпуска"
				},
				cscg8: {
					zh: "终端名称",
					en: "Terminal Name",
					vi: "Tên thiết bị đầu cuối",
					ru: "Название терминала"
				},
				cscg9: {
					zh: "组织结构",
					en: "Organizational Structure",
					vi: "Cơ cấu tổ chức",
					ru: "структура"
				},
				cscg10: {
					zh: "分辨率",
					en: "Resolution",
					vi: "Độ phân giải",
					ru: "разрешение"
				},
				cscg11: {
					zh: "设备类型",
					en: "Equipment type",
					vi: "Loại thiết bị",
					ru: "Тип устройства"
				},
				cscg12: {
					zh: "设备状态",
					en: "device status",
					vi: "trạng thái thiết bị",
					ru: "Состояние устройства"
				},
				cscg13: {
					zh: "业务属性",
					en: "Business attributes",
					vi: "Thuộc tính nghiệp vụ",
					ru: "Бизнес-атрибуты"
				},
				cscg14: {
					zh: "覆盖发布",
					en: "Coverage Release",
					vi: "Ghi đè lên bản phát hành",
					ru: "Выпуск страхового покрытия"
				},
				cscg15: {
					zh: "追加发布",
					en: "Additional Release",
					vi: "Bản phát hành bổ sung",
					ru: "Дополнительный выпуск"
				},
				cscg16: {
					zh: "ids格式是....",
					en: "The format of ids is...",
					vi: "Định dạng của id là...",
					ru: "Формат идентификаторов таков...."
				},
				cscg17: {
					zh: "选择的设备是...",
					en: "The device selected is...",
					vi: "Thiết bị được chọn là...",
					ru: "Выбранное устройство является..."
				},
				cscg18: {
					zh: "发布成功",
					en: "Published successfully",
					vi: "Xuất bản thành công",
					ru: "Успешно выпущенный"
				},
				cscg19: {
					zh: "请输入关键词",
					en: "Please enter a keyword",
					vi: "Vui lòng nhập từ khóa",
					ru: "Пожалуйста, введите ключевые слова"
				}
			},
			NewInterCut: {
				cscn1: {
					zh: "保存",
					en: "save",
					vi: "Lưu",
					ru: "сохранить"
				},
				cscn2: {
					zh: "事件",
					en: "event",
					vi: "sự kiện",
					ru: "событие"
				},
				cscn3: {
					zh: "请输入插播事件名称",
					en: "Please enter the name of the interstitial event",
					vi: "Vui lòng nhập tên của sự kiện xen kẽ",
					ru: "Пожалуйста, введите название промежуточного события"
				},
				cscn4: {
					zh: "事件名称不能为空！",
					en: "Event name cannot be empty!",
					vi: "Tên sự kiện không được để trống!",
					ru: "Название события не может быть пустым!"
				},
				cscn5: {
					zh: "类型",
					en: "type",
					vi: "Loại",
					ru: "тип"
				},
				cscn6: {
					zh: "请选择插播类型",
					en: "Please select the type of insert",
					vi: "Vui lòng chọn loại chèn",
					ru: "Пожалуйста, выберите тип вставки"
				},
				cscn7: {
					zh: "请选择插播事件类型！",
					en: "Please select the type of interstitial event!",
					vi: "Vui lòng chọn loại sự kiện xen kẽ!",
					ru: "Пожалуйста, выберите тип промежуточного события!"
				},
				cscn8: {
					zh: "播放列表",
					en: "playlist",
					vi: "danh sách phát",
					ru: "список воспроизведения"
				},
				cscn9: {
					zh: "片源",
					en: "Source",
					vi: "Nguồn",
					ru: "Источник пленки"
				},
				cscn10: {
					zh: "片源时长",
					en: "Source duration",
					vi: "Thời lượng nguồn",
					ru: "Исходное время"
				},
				cscn11: {
					zh: "播放次数",
					en: "Views",
					vi: "Lượt xem",
					ru: "Количество воспроизведений"
				},
				cscn12: {
					zh: "修改片源",
					en: "Modify the source",
					vi: "Sửa đổi nguồn",
					ru: "Измените источник пленки"
				},
				cscn13: {
					zh: "选择片源",
					en: "Select source",
					vi: "Chọn nguồn",
					ru: "Выберите источник пленки"
				},
				cscn14: {
					zh: "分辨率",
					en: "Resolution",
					vi: "Độ phân giải",
					ru: "разрешение"
				},
				cscn15: {
					zh: "请选择分辨率",
					en: "Please select resolution",
					vi: "Vui lòng chọn độ phân giải",
					ru: "Пожалуйста, выберите разрешение"
				},
				cscn16: {
					zh: "请问是否要永久删除当前片源？",
					en: "Do you want to permanently delete the current source?",
					vi: "Bạn có muốn xóa vĩnh viễn nguồn hiện tại không?",
					ru: "Вы хотите навсегда удалить текущий источник видеозаписи?"
				},
				cscn17: {
					zh: "新建插播",
					en: "Create a new insert",
					vi: "Tạo một phần chèn mới",
					ru: "Новый интерстициальный"
				},
				cscn18: {
					zh: "新建插播事件成功!",
					en: "Created a new insert event successfully!",
					vi: "Đã tạo thành công một sự kiện chèn mới!",
					ru: "Новое промежуточное мероприятие прошло успешно!"
				},
				cscn19: {
					zh: "编辑插播",
					en: "Edit Insert",
					vi: "Chỉnh sửa chèn",
					ru: "Редактировать междурядья"
				},
				cscn20: {
					zh: "编辑插播事件成功",
					en: "Edited the interstitial event successfully",
					vi: "Đã chỉnh sửa thành công sự kiện xen kẽ",
					ru: "Успешно отредактируйте промежуточное событие"
				}
			},
			PlanDetailDialog: {
				cscp1: {
					zh: "失效日期",
					en: "Expiration Date",
					vi: "Ngày hết hạn",
					ru: "Срок годности"
				}
			},
			PlayPlan: {
				cscpp1: {
					zh: "发布成功",
					en: "Published successfully",
					vi: "Xuất bản thành công",
					ru: "Успешно выпущенный"
				}
			},
			ProgramSetting: {
				cscps1: {
					zh: "请选择组织结构",
					en: "Please select your organizational structure",
					vi: "Vui lòng chọn cơ cấu tổ chức của bạn",
					ru: "Пожалуйста, выберите организационную структуру"
				},
				cscps2: {
					zh: "请选择设备类型",
					en: "Please select device type",
					vi: "Vui lòng chọn loại thiết bị",
					ru: "Пожалуйста, выберите тип устройства"
				},
				cscps3: {
					zh: "请选择分辨率",
					en: "Please select resolution",
					vi: "Vui lòng chọn độ phân giải",
					ru: "Пожалуйста, выберите разрешение"
				},
				cscps4: {
					zh: "请选择设备",
					en: "Please select your device",
					vi: "Vui lòng chọn thiết bị của bạn",
					ru: "Пожалуйста, выберите устройство"
				},
				cscps5: {
					zh: "请填写节目名称!",
					en: "Please fill in the program name!",
					vi: "Vui lòng điền tên chương trình!",
					ru: "Пожалуйста, введите название программы!"
				},
				cscps6: {
					zh: "请选择组织结构!",
					en: "Please select your organizational structure!",
					vi: "Vui lòng chọn cơ cấu tổ chức của bạn!",
					ru: "Пожалуйста, выберите организационную структуру!"
				},
				cscps7: {
					zh: "请选择设备类型!",
					en: "Please select the device type!",
					vi: "Vui lòng chọn loại thiết bị!",
					ru: "Пожалуйста, выберите тип устройства!"
				},
				cscps8: {
					zh: "请选择设备!",
					en: "Please select your device!",
					vi: "Vui lòng chọn thiết bị của bạn!",
					ru: "Пожалуйста, выберите устройство!"
				},
				cscps9: {
					zh: "请选择屏幕分辨率!",
					en: "Please select your screen resolution!",
					vi: "Vui lòng chọn độ phân giải màn hình của bạn!",
					ru: "Пожалуйста, выберите разрешение экрана!"
				},
				cscps10: {
					zh: "已加载全部设备！",
					en: "All devices loaded!",
					vi: "Tất cả các thiết bị đã được tải!",
					ru: "Все устройства были загружены!"
				},
				cscps11: {
					zh: "设备不在线!",
					en: "The device is offline!",
					vi: "Thiết bị đang ngoại tuyến!",
					ru: "Устройство не подключено к сети!"
				}
			},
			ScheduleItem: {
				cscs1: {
					zh: "至",
					en: "to",
					vi: "ĐẾN",
					ru: "до"
				},
				cscs2: {
					zh: "日期",
					en: "date",
					vi: "ngày",
					ru: "дата"
				},
				cscs3: {
					zh: "选择日期",
					en: "Select Date",
					vi: "Chọn ngày",
					ru: "Выберите дату"
				},
				cscs4: {
					zh: "每周",
					en: "weekly",
					vi: "hàng tuần",
					ru: "каждая неделя"
				}
			},
			ShowPreview: {
				cscsp1: {
					zh: "节目时长",
					en: "Program duration",
					vi: "Thời lượng chương trình",
					ru: "Длительность"
				}
			},
			UrgencyPlan: {
				cscu1: {
					zh: "发布成功",
					en: "Published successfully",
					vi: "Xuất bản thành công",
					ru: "Успешно выпущенный"
				}
			}
		},
		windows: {
			children: {
				AttrList: {
					AttrRss: {
						cswcaa1: {
							zh: "特效1",
							en: "Effect 1",
							vi: "Hiệu ứng 1",
							ru: "Специальный эффект 1"
						}
					},
					AttrTimewait: {
						cswcaat1: {
							zh: "选择日期时间",
							en: "Select date and time",
							vi: "Chọn ngày và giờ",
							ru: "Выберите дату и время"
						}
					}
				},
				ToolsList: {
					ToolIClock: {
						cswctt1: {
							zh: "年月日",
							en: "year month day",
							vi: "năm tháng ngày",
							ru: "Год, месяц, день"
						},
						cswctt2: {
							zh: "星期",
							en: "Week",
							vi: "Tuần",
							ru: "неделя"
						}
					},
					ToolNClock: {
						cswcttn1: {
							zh: "农历",
							en: "lunar calendar",
							vi: "âm lịch",
							ru: "Лунный календарь"
						},
						cswcttn2: {
							zh: "年月日",
							en: "year month day",
							vi: "năm tháng ngày",
							ru: "Год, месяц, день"
						}
					}
				},
				TerminalList: {
					cswctl1: {
						zh: "拼命发布中，请稍后...",
						en: "Posting urgently, please wait...",
						vi: "Đang đăng gấp, vui lòng đợi...",
						ru: "Пожалуйста, подождите с выпуском..."
					},
					cswctl2: {
						zh: "覆盖发布",
						en: "Coverage Release",
						vi: "Ghi đè lên bản phát hành",
						ru: "Выпуск страхового покрытия"
					},
					cswctl3: {
						zh: "追加发布",
						en: "Additional Release",
						vi: "Bản phát hành bổ sung",
						ru: "Дополнительный выпуск"
					}
				},
				Vdr: {
					cswcv1: {
						zh: "铺满整个屏幕",
						en: "Spread all over the screen",
						vi: "Trải khắp màn hình",
						ru: "Растянуть на весь экран"
					},
					cswcv2: {
						zh: "还原",
						en: "reduction",
						vi: "Khôi phục",
						ru: "восстановить"
					},
					cswcv3: {
						zh: "关闭窗口",
						en: "close the window",
						vi: "đóng cửa sổ",
						ru: "Закройте окно"
					}
				},
				VdrSplit: {
					cswcvs1: {
						zh: "网格布局：单屏",
						en: "Grid Layout: Single Screen",
						vi: "Bố cục lưới Màn hình đơn",
						ru: "Расположение сетки: на одном экране"
					},
					cswcvs2: {
						zh: "网格布局：二等分",
						en: "Grid layout: Bisection",
						vi: "Bố cục lưới: chia đôi",
						ru: "Расположение сетки: две точки"
					},
					cswcvs3: {
						zh: "网格布局：三等分",
						en: "Grid layout: thirds",
						vi: "Bố cục lưới: chia ba",
						ru: "Расположение сетки: три равные части"
					},
					cswcvs4: {
						zh: "网格布局：四等分",
						en: "Grid layout: quarters",
						vi: "Bố cục lưới: chia bốn",
						ru: "Расположение сетки: четыре равные части"
					},
					cswcvs5: {
						zh: "网格布局：自定义",
						en: "Grid Layout: Custom",
						vi: "Bố cục lưới tùy chỉnh",
						ru: "Расположение сетки: пользовательское"
					},
					cswcvs6: {
						zh: "取消",
						en: "Cancel",
						vi: "Hủy bỏ",
						ru: "отменять"
					},
					cswcvs7: {
						zh: "确定",
						en: "Sure",
						vi: "Chắc chắn",
						ru: "уверенный"
					}
				},
				WindowList: {
					cswcw1: {
						zh: "图片",
						en: "picture",
						vi: "hình ảnh",
						ru: "картинка"
					},
					cswcw2: {
						zh: "视频",
						en: "video",
						vi: "băng hình",
						ru: "видео"
					}
				}
			},
			scripts: {
				animations: {
					cswsa1: {
						zh: "无",
						en: "none",
						vi: "không có",
						ru: "не быть"
					},
					cswsa2: {
						zh: "随机",
						en: "random",
						vi: "ngẫu nhiên",
						ru: "случайный"
					},
					cswsa3: {
						zh: "百叶窗",
						en: "Shutters",
						vi: "Cửa chớp",
						ru: "жалюзи"
					},
					cswsa4: {
						zh: "擦除",
						en: "Erase",
						vi: "Xoá",
						ru: "стирать"
					},
					cswsa5: {
						zh: "盒状",
						en: "Box",
						vi: "Hộp",
						ru: "Форма коробки"
					},
					cswsa6: {
						zh: "阶梯",
						en: "ladder",
						vi: "thang",
						ru: "лестница"
					},
					cswsa7: {
						zh: "菱形",
						en: "diamond",
						vi: "kim cương",
						ru: "Ромб"
					},
					cswsa8: {
						zh: "轮子",
						en: "wheel",
						vi: "bánh xe",
						ru: "колесо"
					},
					cswsa9: {
						zh: "劈裂",
						en: "Cleavage",
						vi: "sự phân chia",
						ru: "Расщеплять"
					},
					cswsa10: {
						zh: "切入",
						en: "Cut in",
						vi: "Cắt",
						ru: "Разрезать"
					},
					cswsa11: {
						zh: "棋盘",
						en: "checkerboard",
						vi: "bàn cờ",
						ru: "шахматная доска"
					},
					cswsa12: {
						zh: "扇形展开",
						en: "Fanning",
						vi: "quạt",
						ru: "Веерообразное расширение"
					},
					cswsa13: {
						zh: "十字线条",
						en: "Crosshairs",
						vi: "Chữ thập",
						ru: "Поперечная линия"
					},
					cswsa14: {
						zh: "向内溶解",
						en: "Dissolve inwards",
						vi: "Hòa tan vào trong",
						ru: "Раствориться вовнутрь"
					},
					cswsa15: {
						zh: "圆形扩展",
						en: "Circular expansion",
						vi: "Mở rộng vòng tròn",
						ru: "Круговое расширение"
					}
				},
				toolsList: {
					cswst1: {
						zh: "文本",
						en: "text",
						vi: "chữ",
						ru: "текст"
					},
					cswst2: {
						zh: "数字时钟",
						en: "Digital clock",
						vi: "Đồng hồ kỹ thuật số",
						ru: "Цифровые часы"
					},
					cswst3: {
						zh: "模拟时钟",
						en: "Analog clock",
						vi: "Đồng hồ analog",
						ru: "Аналоговые часы"
					},
					cswst4: {
						zh: "天气",
						en: "weather",
						vi: "thời tiết",
						ru: "погода"
					},
					cswst5: {
						zh: "正计时",
						en: "Counting",
						vi: "Đếm",
						ru: "Синхронизация"
					},
					cswst6: {
						zh: "倒计时",
						en: "Countdown",
						vi: "Đếm ngược",
						ru: "обратный отсчет"
					},
					cswst7: {
						zh: "流媒体",
						en: "stream media",
						vi: "truyền phát phương tiện truyền thông",
						ru: "Потоковое мультимедиа"
					},
					cswst8: {
						zh: "图片",
						en: "picture",
						vi: "hình ảnh",
						ru: "картинка"
					},
					cswst9: {
						zh: "视频",
						en: "video",
						vi: "băng hình",
						ru: "видео"
					},
					cswst10: {
						zh: "网页",
						en: "Web page",
						vi: "trang web",
						ru: "страница"
					}
				}
			},
			index: {
				cswi1: {
					zh: "节目模板",
					en: "Program Template",
					vi: "Mẫu chương trình",
					ru: "Шаблон программы"
				}
			}
		},
		InterCutManage: {
			csl1: {
				zh: "事件",
				en: "event",
				vi: "sự kiện",
				ru: "событие"
			},
			csl2: {
				zh: "片源名称",
				en: "Source Name",
				vi: "Tên nguồn",
				ru: "Имя источника"
			},
			csl3: {
				zh: "播放次数",
				en: "Views",
				vi: "Lượt xem",
				ru: "Количество воспроизведений"
			},
			csl4: {
				zh: "播放",
				en: "Play",
				vi: "phát",
				ru: "проиграть"
			},
			csl5: {
				zh: "创建时间",
				en: "Creation time",
				vi: "Thời gian sáng tạo",
				ru: "Время создания"
			},
			csl6: {
				zh: "创建者",
				en: "creator",
				vi: "người sáng tạo",
				ru: "основатель"
			},
			csl7: {
				zh: "操作",
				en: "operate",
				vi: "vận hành",
				ru: "работать"
			},
			csl8: {
				zh: "类型名称",
				en: "type name",
				vi: "tên loại",
				ru: "Имя типа"
			},
			csl9: {
				zh: "取 消",
				en: "Cancel",
				vi: "Hủy bỏ",
				ru: "отменять"
			},
			csl10: {
				zh: "确 定",
				en: "Sure",
				vi: "Chắc chắn",
				ru: "определять"
			},
			csl11: {
				zh: "删除类型",
				en: "Deletion Type",
				vi: "Loại xóa",
				ru: "Тип удаления"
			},
			csl12: {
				zh: "请问是否要永久删除当前类型？",
				en: "Do you want to permanently delete the current type?",
				vi: "Bạn có muốn xóa vĩnh viễn loại hiện tại không?",
				ru: "Вы хотите удалить текущий тип навсегда?"
			},
			csl13: {
				zh: "删除事件",
				en: "Deleting an event",
				vi: "Xóa một sự kiện",
				ru: "Удалить событие"
			},
			csl14: {
				zh: "请问是否要永久删除当前选中事件？",
				en: "Do you want to permanently delete the currently selected event?",
				vi: "Bạn có muốn xóa vĩnh viễn sự kiện hiện được chọn không?",
				ru: "Вы хотите навсегда удалить текущее выбранное событие?"
			},
			csl15: {
				zh: "插播筛选",
				en: "Interlude Filter",
				vi: "Bộ lọc xen kẽ",
				ru: "Интерстициальный скрининг"
			},
			csl16: {
				zh: "时间范围",
				en: "time limit",
				vi: "thời gian giới hạn",
				ru: "временные рамки"
			},
			csl17: {
				zh: "至",
				en: "to",
				vi: "ĐẾN",
				ru: "до"
			},
			csl18: {
				zh: "开始日期",
				en: "start date",
				vi: "ngày bắt đầu",
				ru: "Дата начала"
			},
			csl19: {
				zh: "结束日期",
				en: "End Date",
				vi: "Ngày cuối",
				ru: "Дата окончания"
			},
			csl20: {
				zh: "请输入类型名称",
				en: "Please enter a type name",
				vi: "Vui lòng nhập tên loại",
				ru: "Пожалуйста, введите название типа"
			},
			csl21: {
				zh: "新建类型",
				en: "New Type",
				vi: "Kiểu mới",
				ru: "Новый тип"
			},
			csl22: {
				zh: "类型重命名",
				en: "Type Renaming",
				vi: "Đổi tên loại",
				ru: "Введите переименование"
			},
			csl23: {
				zh: "未选择插播事件",
				en: "No interstitial event selected",
				vi: "Không có sự kiện xen kẽ nào được chọn",
				ru: "Промежуточное событие не выбрано"
			}
		},
		PlayListTable: {
			csp1: {
				zh: "发布详情",
				en: "Release details",
				vi: "Chi tiết phát hành",
				ru: "Подробности о выпуске"
			},
			csp2: {
				zh: "确认删除？",
				en: "confirm deletion?",
				vi: "xác nhận xóa?",
				ru: "Подтвердить удаление?"
			}
		},
		ProgramManage: {
			cspm1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры"
			},
			cspm2: {
				zh: "节目时长",
				en: "Program duration",
				vi: "Thời lượng chương trình",
				ru: "Длительность"
			},
			cspm3: {
				zh: "发布",
				en: "release",
				vi: "giải phóng",
				ru: "сообщать"
			},
			cspm4: {
				zh: "详情",
				en: "Details",
				vi: "Chi tiết",
				ru: "подробности"
			},
			cspm5: {
				zh: "编辑",
				en: "edit",
				vi: "biên tập",
				ru: "редактор"
			},
			cspm6: {
				zh: "复制",
				en: "copy",
				vi: "sao chép",
				ru: "копировать"
			},
			cspm7: {
				zh: "删除",
				en: "delete",
				vi: "xóa bỏ",
				ru: "стирать"
			},
			cspm8: {
				zh: "节目复制成功!",
				en: "Program copied successfully!",
				vi: "Chương trình được sao chép thành công!",
				ru: "Программа была успешно скопирована!"
			},
			cspm9: {
				zh: "请选中需要删除的节目!",
				en: "Please select the program you want to delete!",
				vi: "Vui lòng chọn chương trình bạn muốn xóa!",
				ru: "Пожалуйста, выберите программу, которую необходимо удалить!"
			},
			cspm10: {
				zh: "节目发布成功！",
				en: "The program was successfully released!",
				vi: "Chương trình đã được phát hành thành công!",
				ru: "Программа была успешно выпущена!"
			}
		}
	},
	system: {
		children: {
			AccessLayout: {
				cscha1: {
					zh: "测试",
					en: "test",
					vi: "Bài kiểm tra",
					ru: "проверка"
				}
			},
			SystemSet: {
				cscss1: {
					zh: "系统设置",
					en: "System Settings",
					vi: "Cài đặt hệ thống",
					ru: "Системные настройки"
				},
				cscss2: {
					zh: "网页标题",
					en: "Page title",
					vi: "Tiêu đề trang",
					ru: "Заголовок страницы"
				},
				cscss3: {
					zh: "关闭帮助",
					en: "Close Help",
					vi: "Đóng Trợ giúp",
					ru: "Близкая помощь"
				},
				cscss4: {
					zh: "开启网页帮助",
					en: "Open web help",
					vi: "Mở trợ giúp web",
					ru: "Откройте веб-справку"
				},
				cscss5: {
					zh: "关闭网页帮助",
					en: "Close web help",
					vi: "Đóng trợ giúp trên web",
					ru: "Закрыть веб-справку"
				},
				cscss6: {
					zh: "设置备案号",
					en: "Set the record number",
					vi: "Đặt số bản ghi",
					ru: "Установите рекордный номер"
				},
				cscss7: {
					zh: "备案号",
					en: "case number",
					vi: "số trường hợp",
					ru: "Номер записи"
				},
				cscss8: {
					zh: "应用",
					en: "application",
					vi: "ứng dụng",
					ru: "приложение"
				},
				cscss9: {
					zh: "日志保存时间",
					en: "Log retention period",
					vi: "Khoảng thời gian lưu giữ nhật ký",
					ru: "Время хранения журнала"
				},
				cscss10: {
					zh: "描述文字",
					en: "Description text",
					vi: "văn bản mô tả",
					ru: "Текст описания"
				},
				cscss11: {
					zh: "天",
					en: "sky",
					vi: "bầu trời",
					ru: "день"
				},
				cscss12: {
					zh: "控制按钮配置(勾选折叠)",
					en: "Control button configuration (check fold)",
					vi: "Cấu hình nút điều khiển (kiểm tra Fold)",
					ru: "Настройка кнопки управления (проверьте складывание)"
				}
			}
		},
		helpDocument: {
			csh1: {
				zh: "帮助文档",
				en: "Help Documentation",
				vi: "Tài liệu trợ giúp",
				ru: "Справочный документ"
			},
			csh2: {
				zh: "Kares云平台",
				en: "Kares Cloud Platform",
				vi: "Nền tảng đám mây Kares",
				ru: "Облачная платформа Kares"
			},
			csh3: {
				zh: "PE软件",
				en: "PE Software",
				vi: "Phần mềm PE",
				ru: "Программное обеспечение PE"
			},
			csh4: {
				zh: "手机APP",
				en: "Mobile APP",
				vi: "Ứng dụng di động",
				ru: "Мобильное ПРИЛОЖЕНИЕ"
			}
		},
		MediaManage: {
			csm1: {
				zh: "媒体目录名称",
				en: "Media Directory Name",
				vi: "Tên thư mục phương tiện",
				ru: "Имя каталога мультимедиа"
			},
			csm2: {
				zh: "操作",
				en: "operate",
				vi: "vận hành",
				ru: "работать"
			},
			csm3: {
				zh: "新增目录",
				en: "Add a new directory",
				vi: "Thêm một thư mục mới",
				ru: "Новое оглавление"
			},
			csm4: {
				zh: "英文名称",
				en: "English name",
				vi: "tên tiêng Anh",
				ru: "Английское имя"
			},
			csm5: {
				zh: "中文名称",
				en: "Chinese name",
				vi: "Tên tiếng Trung",
				ru: "Китайское название"
			},
			csm6: {
				zh: "取 消",
				en: "Cancel",
				vi: "Hủy bỏ",
				ru: "отменять"
			},
			csm7: {
				zh: "确 定",
				en: "Sure",
				vi: "Chắc chắn",
				ru: "определять"
			},
			csm8: {
				zh: "请问是否要永久删除当前目录？",
				en: "Do you want to permanently delete the current directory?",
				vi: "Bạn có muốn xóa vĩnh viễn thư mục hiện tại không?",
				ru: "Вы хотите навсегда удалить текущий каталог?"
			},
			csm9: {
				zh: "请输入英文名称",
				en: "Please enter your English name",
				vi: "Vui lòng nhập tên tiếng Anh của bạn",
				ru: "Пожалуйста, введите английское название"
			},
			csm10: {
				zh: "请输入中文名称",
				en: "Please enter your Chinese name",
				vi: "Vui lòng nhập tên tiếng Trung của bạn",
				ru: "Пожалуйста, введите китайское название"
			}
		},
		NodeManage: {
			csn1: {
				zh: "测试",
				en: "test",
				vi: "Bài kiểm tra",
				ru: "проверка"
			},
			csn2: {
				zh: "请输入英文名称",
				en: "Please enter your English name",
				vi: "Vui lòng nhập tên tiếng Anh của bạn",
				ru: "Пожалуйста, введите английское название"
			},
			csn3: {
				zh: "请输入中文名称",
				en: "Please enter your Chinese name",
				vi: "Vui lòng nhập tên tiếng Trung của bạn",
				ru: "Пожалуйста, введите китайское название"
			}
		},
		OperationLog: {
			cso1: {
				zh: "用户名",
				en: "username",
				vi: "tên tài khoản",
				ru: "имя пользователя"
			},
			cso2: {
				zh: "功能",
				en: "Function",
				vi: "Chức năng",
				ru: "функция"
			},
			cso3: {
				zh: "描述",
				en: "describe",
				vi: "mô tả",
				ru: "описание"
			},
			cso4: {
				zh: "操作时间",
				en: "Operation time",
				vi: "Thời gian hoạt động",
				ru: "Время работы"
			}
		},
		OrganizationManage: {
			csom1: {
				zh: "请输入组织结构名称",
				en: "Please enter the name of the organization",
				vi: "Vui lòng nhập tên tổ chức",
				ru: "Пожалуйста, введите название организационной структуры"
			}
		},
		PersonalCenter: {
			cspc1: {
				zh: "未设置",
				en: "Not set",
				vi: "Không được thiết lập",
				ru: "Не установлен"
			}
		},
		ReferralCode: {
			csr1: {
				zh: "推荐码申请",
				en: "Referral code application",
				vi: "Ứng dụng mã giới thiệu",
				ru: "Применение рекомендательного кода"
			},
			csr2: {
				zh: "拼命申请中",
				en: "Desperately applying",
				vi: "Đang côs hết sức để nộp",
				ru: "В настоящее время применяется"
			},
			csr3: {
				zh: "邮箱",
				en: "Mail",
				vi: "Thư",
				ru: "электронная почта"
			},
			csr4: {
				zh: "密码",
				en: "password",
				vi: "mật khẩu",
				ru: "код"
			},
			csr5: {
				zh: "立即申请",
				en: "apply immediately",
				vi: "áp dụng ngay lập tức",
				ru: "Подайте заявку прямо сейчас"
			},
			csr6: {
				zh: "推荐码已发送至您的邮箱，请注意查收！",
				en: "The referral code has been sent to your email, please check it!",
				vi: "Mã giới thiệu đã được gửi vào email của bạn, bạn kiểm tra nhé!",
				ru: "Рекомендательный код был отправлен на ваш почтовый ящик, пожалуйста, обратите внимание и проверьте его!"
			},
			csr7: {
				zh: "立即修改",
				en: "Modify now",
				vi: "Sửa đổi ngay bây giờ",
				ru: "Измените сейчас"
			},
			csr8: {
				zh: "首次登录需修改默认密码！",
				en: "The default password needs to be changed when logging in for the first time!",
				vi: "Mật khẩu mặc định cần được thay đổi khi đăng nhập lần đầu tiên!",
				ru: "Для первого входа в систему вам необходимо изменить пароль по умолчанию!"
			}
		},
		RoleManage: {
			csrm1: {
				zh: "请输入角色名称",
				en: "Please enter a role name",
				vi: "Vui lòng nhập tên vai trò",
				ru: "Пожалуйста, введите название роли"
			},
			csrm2: {
				zh: "长度在2 到 20 个字符",
				en: "Length between 2 and 20 characters",
				vi: "Độ dài từ 2 đến 20 ký tự",
				ru: "Длина - от 2 до 20 символов"
			},
			csrm3: {
				zh: "至少配置一个系统权限！",
				en: "Configure at least one system permission!",
				vi: "Cấu hình ít nhất một quyền hệ thống!",
				ru: "Настройте хотя бы одно системное разрешение!"
			}
		},
		SystemLayout: {
			css1: {
				zh: "网页图标",
				en: "Web Icons",
				vi: "Biểu tượng web",
				ru: "Веб-значок"
			},
			css2: {
				zh: "图片格式必须为.ico",
				en: "The image format must be .ico",
				vi: "Định dạng hình ảnh phải là .ico",
				ru: "Формат изображения должен быть.ico"
			}
		},
		UrgentContent: {
			csu1: {
				zh: "紧急文本",
				vi: "văn bản khẩn cấp",
				ru: "Экстренный текст"
			},
			csu2: {
				zh: "紧急信息名称",
				vi: "Tên thông tin khẩn cấp",
				ru: "Название экстренной информации"
			},
			csu3: {
				zh: "请输入内容",
				vi: "Vui lòng nhập nội dung",
				ru: "Пожалуйста, введите содержание"
			},
			csu4: {
				zh: "紧急信息内容",
				vi: "Nội dung thông tin khẩn cấp",
				ru: "Содержание информации о чрезвычайных ситуациях"
			},
			csu5: {
				zh: "确认保存当前修改?",
				vi: "Bạn có chắc chắn muốn lưu những thay đổi hiện tại không?",
				ru: "Подтвердите, чтобы сохранить текущие изменения?"
			},
			csu6: {
				zh: "确定",
				vi: "Chắc chắn",
				ru: "уверенный"
			},
			csu7: {
				zh: "编辑",
				vi: "biên tập",
				ru: "редактор"
			},
			csu8: {
				zh: "确认删除?",
				vi: "xác nhận xóa?",
				ru: "Подтвердить удаление?"
			},
			csu9: {
				zh: "删除",
				vi: "xóa bỏ",
				ru: "стирать"
			},
			csu10: {
				zh: "新增紧急文本",
				vi: "Thêm văn bản khẩn cấp",
				ru: "Добавить текст экстренной помощи"
			},
			csu11: {
				zh: "紧急版式",
				vi: "Bố trí khẩn cấp",
				ru: "Аварийная планировка"
			},
			csu12: {
				zh: "紧急信息内容",
				vi: "Nội dung thông tin khẩn cấp",
				ru: "Содержание информации о чрезвычайных ситуациях"
			},
			csu13: {
				zh: "(需先将紧急版式内容传到终端)",
				vi: "(Nội dung định dạng khẩn cấp phải được truyền đến thiết bị đầu cuối trước)",
				ru: "(Сначала вам необходимо загрузить содержимое аварийного макета в терминал)"
			},
			csu14: {
				zh: "请输入内容",
				vi: "Vui lòng nhập nội dung",
				ru: "Пожалуйста, введите содержание"
			},
			csu15: {
				zh: "新增紧急版式",
				vi: "Bố cục khẩn cấp mới",
				ru: "Добавлена схема аварийной ситуации"
			},
			csu16: {
				zh: "紧急信息名称",
				vi: "Tên thông tin khẩn cấp",
				ru: "Название экстренной информации"
			}
		},
		UserManage: {
			csum1: {
				zh: "账号",
				en: "account",
				vi: "tài khoản",
				ru: "счет"
			},
			csum2: {
				zh: "姓名",
				en: "Name",
				vi: "Tên",
				ru: "полное имя"
			},
			csum3: {
				zh: "角色",
				en: "Role",
				vi: "Vai trò",
				ru: "роль"
			},
			csum4: {
				zh: "等级",
				en: "grade",
				vi: "cấp",
				ru: "уровень"
			},
			csum5: {
				zh: "备注",
				en: "Remark",
				vi: "Nhận xét",
				ru: "Замечания"
			},
			csum6: {
				zh: "操作",
				en: "operate",
				vi: "vận hành",
				ru: "работать"
			},
			csum7: {
				zh: "组织结构",
				en: "Organizational Structure",
				vi: "Cơ cấu tổ chức",
				ru: "структура"
			},
			csum8: {
				zh: "请选择组织结构",
				en: "Please select your organizational structure",
				vi: "Vui lòng chọn cơ cấu tổ chức của bạn",
				ru: "Пожалуйста, выберите организационную структуру"
			},
			csum9: {
				zh: "角色名称",
				en: "Role Name",
				vi: "Tên vai trò",
				ru: "Имя персонажа"
			},
			csum10: {
				zh: "请选择角色名称",
				en: "Please select a role name",
				vi: "Vui lòng chọn tên vai trò",
				ru: "Пожалуйста, выберите название роли"
			},
			csum11: {
				zh: "管理员: 有全部权限，可创建账号，制作、发布节目，管理设备，审核等。",
				en: "Administrator: Has full permissions, can create accounts, produce and publish programs, manage equipment, review, etc.",
				vi: "Quản trị viên Có đầy đủ quyền, có thể tạo tài khoản, sản xuất và xuất bản chương trình, quản lý thiết bị, đánh giá, v.v.",
				ru: "Администратор: Обладает всеми разрешениями, может создавать учетные записи, создавать и публиковать программы, управлять оборудованием, просматривать и т.д."
			},
			csum12: {
				zh: "审核员: 仅有审核权限；无法创建账号，添加设备、节目，控制设备。",
				en: "Auditor: Has only audit authority; cannot create accounts, add devices, programs, or control devices.",
				vi: "Kiểm toán viên chỉ có thẩm quyền kiểm toán; không thể tạo tài khoản, thêm thiết bị, chương trình hoặc điều khiển thiết bị.",
				ru: "Аудитор: имеет только аудиторские полномочия; не может создавать учетную запись, добавлять оборудование, программы или управлять оборудованием."
			},
			csum13: {
				zh: "操作员: 有制作、发布节目，管理设备权限；无法创建账号及审核。",
				en: "Operator: Has the authority to produce and publish programs, and manage equipment; cannot create accounts or conduct audits.",
				vi: "Nhà điều hành Có quyền sản xuất và xuất bản các chương trình cũng như quản lý thiết bị; không thể tạo tài khoản hoặc tiến hành kiểm toán.",
				ru: "Оператор: Имеет право создавать, публиковать программы и управлять оборудованием; не может создавать учетные записи и просматривать их."
			},
			csum14: {
				zh: "密码",
				en: "password",
				vi: "mật khẩu",
				ru: "код"
			},
			csum15: {
				zh: "确认密码",
				en: "Confirm Password",
				vi: "Xác nhận mật khẩu",
				ru: "Подтвердите пароль"
			},
			csum16: {
				zh: "邮箱",
				en: "Mail",
				vi: "Thư",
				ru: "электронная почта"
			},
			csum17: {
				zh: "取 消",
				en: "Cancel",
				vi: "Hủy bỏ",
				ru: "отменять"
			},
			csum18: {
				zh: "确 定",
				en: "Sure",
				vi: "Chắc chắn",
				ru: "определять"
			},
			csum19: {
				zh: "删除用户",
				en: "delete users",
				vi: "xóa người dùng",
				ru: "Удалить пользователя"
			},
			csum20: {
				zh: "请问是否要永久删除当前角色？",
				en: "Do you want to permanently delete the current role?",
				vi: "Bạn có muốn xóa vĩnh viễn vai trò hiện tại không?",
				ru: "Вы хотите удалить текущую роль навсегда?"
			},
			csum21: {
				zh: "解封设备",
				en: "Unblock device",
				vi: "Bỏ chặn thiết bị",
				ru: "Разблокирующее оборудование"
			},
			csum22: {
				zh: "封禁设备",
				en: "Blocked devices",
				vi: "Thiết bị bị chặn",
				ru: "Запрещенное оборудование"
			},
			csum23: {
				zh: "请问是否要解封当前或从属设备？",
				en: "Do you want to unblock the current or slave device?",
				vi: "Bạn có muốn bỏ chặn thiết bị hiện tại hoặc thiết bị phụ?",
				ru: "Вы хотите разблокировать текущее или подчиненное устройство?"
			},
			csum24: {
				zh: "请问是否要封禁当前或从属设备？",
				en: "Do you want to block the current or subordinate device?",
				vi: "Bạn có muốn chặn thiết bị hiện tại hoặc thiết bị cấp dưới không?",
				ru: "Вы хотите заблокировать текущие или подчиненные устройства?"
			},
			csum25: {
				zh: "请输入确认密码",
				en: "Please enter the confirmation password",
				vi: "Vui lòng nhập mật khẩu xác nhận",
				ru: "Пожалуйста, введите пароль для подтверждения"
			},
			csum26: {
				zh: "两次输入密码不一致!",
				en: "The passwords you entered twice do not match!",
				vi: "Mật khẩu bạn nhập hai lần không khớp!",
				ru: "Введенный дважды пароль является несогласованным!"
			},
			csum27: {
				zh: "新增用户",
				en: "New users",
				vi: "Những người dùng mới",
				ru: "Новые пользователи"
			},
			csum28: {
				zh: "请输入姓名",
				en: "Please type in your name",
				vi: "Vui lòng nhập tên của bạn",
				ru: "Пожалуйста, введите свое имя"
			},
			csum29: {
				zh: "请输入密码",
				en: "Please enter your password",
				vi: "Vui lòng nhập mật khẩu của bạn",
				ru: "Пожалуйста, введите пароль"
			},
			csum30: {
				zh: "必须八位以上且包含字母,数字以及特殊字符",
				en: "Must be at least eight characters long and contain letters, numbers, and special characters",
				vi: "Phải dài ít nhất tám ký tự và chứa các chữ cái, số và ký tự đặc biệt",
				ru: "Должно содержать более восьми цифр и буквы, цифры и специальные символы"
			},
			csum31: {
				zh: "角色名称不能为空",
				en: "Role name cannot be empty",
				vi: "Tên vai trò không được để trống",
				ru: "Имя роли не может быть пустым"
			},
			csum32: {
				zh: "组织结构不能为空",
				en: "Organization structure cannot be empty",
				vi: "Cơ cấu tổ chức không được để trống",
				ru: "Организационная структура не может быть пустой"
			},
			csum33: {
				zh: "解禁当前",
				en: "Unban current",
				vi: "Bỏ cấm hiện tại",
				ru: "Отмена действующего запрета"
			},
			csum34: {
				zh: "解禁从属",
				en: "Unban Dependents",
				vi: "Bỏ cấm người phụ thuộc",
				ru: "Отмените запрет!"
			},
			csum35: {
				zh: "新增用户",
				en: "New users",
				vi: "Những người dùng mới",
				ru: "Новые пользователи"
			},
			csum36: {
				zh: "修改用户",
				en: "Modify User",
				vi: "Sửa đổi người dùng",
				ru: "Изменить пользователя"
			},
			csum37: {
				zh: "账号不允许为空!",
				en: "The account number cannot be empty!",
				vi: "Số tài khoản không được để trống!",
				ru: "Учетная запись не должна быть пустой!"
			},
			csum38: {
				zh: "账号中只能包含数字、字母、下划线!",
				en: "The account number can only contain numbers, letters, and underscores!",
				vi: "Số tài khoản chỉ được chứa số, chữ cái và dấu gạch dưới!",
				ru: "В учетную запись могут быть включены только цифры, буквы и символы подчеркивания!"
			},
			csum39: {
				zh: "请设置账号长度为3~20个字符!",
				en: "Please set the account length to 3~20 characters!",
				vi: "Vui lòng đặt độ dài tài khoản thành 3 ~ 20 ký tự!",
				ru: "Пожалуйста, укажите длину учетной записи от 3 до 20 символов!"
			},
			csum40: {
				zh: "当前账号已注册，请重输入!",
				en: "The current account has been registered, please re-enter!",
				vi: "Tài khoản hiện tại đã được đăng ký, vui lòng nhập lại!",
				ru: "Текущая учетная запись была зарегистрирована, пожалуйста, введите ее повторно!"
			}
		}
	},
	terminal: {
		children: {
			DeviceDetailHight: {
				DeviceControl: {
					ctcdd1: {
						zh: "亮度",
						en: "brightness",
						vi: "độ sáng",
						ru: "яркость"
					},
					ctcdd2: {
						zh: "声音",
						en: "sound",
						vi: "âm thanh",
						ru: "голос"
					}
				},
				DeviceInfo: {
					ctcdde1: {
						zh: "设备名称",
						en: "Device Name",
						vi: "Tên thiết bị",
						ru: "Имя устройства"
					},
					ctcdde2: {
						zh: "屏幕类型",
						en: "Screen type",
						vi: "Loại màn hình",
						ru: "Тип экрана"
					},
					ctcdde3: {
						zh: "分辨率",
						en: "Resolution",
						vi: "Độ phân giải",
						ru: "разрешение"
					},
					ctcdde4: {
						zh: "版本号",
						en: "version number",
						vi: "số phiên bản",
						ru: "Номер версии"
					},
					ctcdde5: {
						zh: "系统信息",
						en: "system message",
						vi: "tin nhăn hệ thông",
						ru: "Системная информация"
					},
					ctcdde6: {
						zh: "备注",
						en: "Remark",
						vi: "Nhận xét",
						ru: "Замечания"
					},
					ctcdde7: {
						zh: "安装日期",
						en: "Installation Date",
						vi: "Ngày cài đặt",
						ru: "Дата установки"
					},
					ctcdde8: {
						zh: "运行状态",
						en: "Operating status",
						vi: "Trạng thái hoạt động",
						ru: "Рабочее состояние"
					},
					ctcdde9: {
						zh: "正在播放",
						en: "Now Playing",
						vi: "Đang phát",
						ru: "Играющий"
					},
					ctcdde10: {
						zh: "盒子时钟",
						en: "Box Clock",
						vi: "Đồng hồ hộp",
						ru: "Часы-шкатулка"
					},
					ctcdde11: {
						zh: "当前时区",
						en: "Current time zone",
						vi: "Múi giờ hiện tại",
						ru: "Текущий часовой пояс"
					},
					ctcdde12: {
						zh: "运行时间",
						en: "operation hours",
						vi: "giờ hoạt động",
						ru: "Время выполнения"
					},
					ctcdde13: {
						zh: "定时指令",
						en: "Timing instructions",
						vi: "Hướng dẫn tính thời gian",
						ru: "Команда синхронизации"
					},
					ctcdde14: {
						zh: "定时播放",
						en: "Scheduled playback",
						vi: "Phát lại theo lịch trình",
						ru: "Синхронизированное воспроизведение"
					},
					ctcdde15: {
						zh: "同步播放",
						en: "Synchronous playback",
						vi: "Phát lại đồng bộ",
						ru: "Синхронное воспроизведение"
					},
					ctcdde16: {
						zh: "信号源",
						en: "signal source",
						vi: "nguồn tín hiệu",
						ru: "источник сигнала"
					},
					ctcdde17: {
						zh: "内存空间",
						en: "Memory space",
						vi: "Không gian bộ nhớ",
						ru: "Объем памяти"
					},
					ctcdde18: {
						zh: "IP地址",
						en: "IP address",
						vi: "địa chỉ IP",
						ru: "ip-адрес"
					},
					ctcdde19: {
						zh: "云看护",
						en: "Cloud Care",
						vi: "Chăm sóc đám mây",
						ru: "Уход за облаком"
					},
					ctcdde20: {
						zh: "最近心跳",
						en: "Recent heartbeat",
						vi: "Nhịp tim gần đây",
						ru: "Недавнее сердцебиение"
					},
					ctcdde21: {
						zh: "设备语言",
						en: "Device language",
						vi: "Ngôn ngữ thiết bị",
						ru: "Язык устройства"
					},
					ctcdde22: {
						zh: "安装日期",
						en: "Installation Date",
						vi: "Ngày cài đặt",
						ru: "Дата установки"
					},
					ctcdde23: {
						zh: "运行状态",
						en: "Operating status",
						vi: "Trạng thái hoạt động",
						ru: "Рабочее состояние"
					},
					ctcdde24: {
						zh: "离线",
						en: "Offline",
						vi: "Ngoại tuyến",
						ru: "не в сети"
					},
					ctcdde25: {
						zh: "关屏",
						en: "Turn off the screen",
						vi: "Tắt màn hình",
						ru: "Выключите экран"
					},
					ctcdde26: {
						zh: "开屏",
						en: "Open screen",
						vi: "Mở màn hình",
						ru: "Открытый экран"
					},
					ctcdde27: {
						zh: "HDMI优先",
						en: "HDMI First",
						vi: "Ưu tiên HDMI",
						ru: "Приоритет HDMI"
					},
					ctcdde28: {
						zh: "异步信号",
						en: "Asynchronous signals",
						vi: "Tín hiệu không đồng bộ",
						ru: "Асинхронный сигнал"
					},
					ctcdde29: {
						zh: "同步信号",
						en: "Synchronous signal",
						vi: "Tín hiệu đồng bộ",
						ru: "Сигнал синхронизации"
					},
					ctcdde30: {
						zh: "操作系统",
						en: "operating system",
						vi: "hệ điều hành",
						ru: "операционная система"
					},
					ctcdde31: {
						zh: "运行内存",
						en: "Running Memory",
						vi: "Bộ nhớ đang chạy",
						ru: "Работающая память"
					},
					ctcdde32: {
						zh: "有线网络",
						en: "Wired network",
						vi: "Mạng có dây",
						ru: "Проводная сеть"
					}
				},
				index_b: {
					ctcdi1: {
						zh: "云看护：",
						en: "Cloud Care:",
						vi: "Chăm sóc đám mây",
						ru: "Уход за облаком："
					},
					ctcdi2: {
						zh: "开启",
						en: "Open",
						vi: "Mở",
						ru: "включать"
					},
					ctcdi3: {
						zh: "关闭",
						en: "closure",
						vi: "Khép kín",
						ru: "закрывать"
					},
					ctcdi4: {
						zh: "暂无数据",
						en: "No data",
						vi: "Không có dữ liệu",
						ru: "Нет доступных данных"
					},
					ctcdi5: {
						zh: "已开启",
						en: "Turned on",
						vi: "Đã bật",
						ru: "Включенный"
					},
					ctcdi6: {
						zh: "未开启",
						en: "Unopened",
						vi: "Chưa mở",
						ru: "Не включен"
					},
					ctcdi7: {
						zh: "GPS同步",
						en: "GPS Sync",
						vi: "Đồng bộ hóa GPS",
						ru: "GPS-синхронизация"
					},
					ctcdi8: {
						zh: "网络同步",
						en: "Network synchronization",
						vi: "Đồng bộ hóa mạng",
						ru: "Сетевая синхронизация"
					},
					ctcdi9: {
						zh: "定时播放",
						en: "Scheduled playback",
						vi: "Phát lại theo lịch trình",
						ru: "Синхронизированное воспроизведение"
					},
					ctcdi10: {
						zh: "WIFI网络",
						en: "WIFI network",
						vi: "Mạng wifi",
						ru: "Сеть Wi-FI"
					},
					ctcdi11: {
						zh: "有线网络",
						en: "Wired network",
						vi: "Mạng có dây",
						ru: "Проводная сеть"
					},
					ctcdi12: {
						zh: "同步播放",
						en: "Synchronous playback",
						vi: "Phát lại đồng bộ",
						ru: "Синхронное воспроизведение"
					}
				},
				index: {
					ctcdin1: {
						zh: "截图加载中 ...",
						en: "Loading screenshots...",
						vi: "Đang tải ảnh chụp màn hình...",
						ru: "Загружается скриншот..."
					},
					ctcdin2: {
						zh: "设备信息加载中 ...",
						en: "Loading device information...",
						vi: "Đang tải thông tin thiết bị...",
						ru: "Загружается информация об устройстве..."
					},
					ctcdin3: {
						zh: "开启",
						en: "Open",
						vi: "Mở",
						ru: "включать"
					},
					ctcdin4: {
						zh: "关闭",
						en: "closure",
						vi: "Khép kín",
						ru: "закрывать"
					},
					ctcdin5: {
						zh: "指令设置成功！",
						en: "The command was set successfully!",
						vi: "Lệnh đã được đặt thành công!",
						ru: "Инструкция была успешно выполнена!"
					}
				}
			},
			item: {
				Camera: {
					ctcic1: {
						zh: "选项",
						en: "Options",
						vi: "Tùy chọn",
						ru: "вариант"
					},
					ctcic2: {
						zh: "复制成功",
						en: "Copy Success",
						vi: "Sao chép thành công",
						ru: "Успешное копирование"
					}
				},
				CaptureList: {
					ctcicl1: {
						zh: "时间范围查询",
						en: "Time range query",
						vi: "Truy vấn phạm vi thời gian",
						ru: "Запрос временного диапазона"
					},
					ctcicl2: {
						zh: "至",
						en: "to",
						vi: "ĐẾN",
						ru: "до"
					},
					ctcicl3: {
						zh: "开始日期",
						en: "start date",
						vi: "ngày bắt đầu",
						ru: "Дата начала"
					},
					ctcicl4: {
						zh: "结束日期",
						en: "End Date",
						vi: "Ngày cuối",
						ru: "Дата окончания"
					},
					ctcicl5: {
						zh: "删除截图",
						en: "Delete screenshots",
						vi: "Xóa ảnh chụp màn hình",
						ru: "Удалить скриншот"
					},
					ctcicl6: {
						zh: "最近一周",
						en: "Last week",
						vi: "Tuần trước",
						ru: "Прошлая неделя"
					},
					ctcicl7: {
						zh: "最近一个月",
						en: "Last month",
						vi: "Tháng trước",
						ru: "Прошлый месяц"
					},
					ctcicl8: {
						zh: "最近三个月",
						en: "Last three months",
						vi: "Ba tháng qua",
						ru: "Последние три месяца"
					},
					ctcicl9: {
						zh: "未选中需要删除截图！",
						en: "Uncheck the need to delete the screenshot!",
						vi: "Bỏ chọn sự cần thiết phải xóa ảnh chụp màn hình!",
						ru: "Снимок экрана необходимо удалить, если он не выбран!"
					},
					ctcicl10: {
						zh: "删除成功！",
						en: "successfully deleted!",
						vi: "đã xóa thành công!",
						ru: "Удалено успешно!"
					}
				},
				CentralControl: {
					ctcicc1: {
						zh: "指令加载中",
						en: "Instructions loading",
						vi: "Hướng dẫn tải",
						ru: "Загрузка инструкций"
					},
					ctcicc2: {
						zh: "指令名称",
						en: "Command name",
						vi: "Tên lệnh",
						ru: "Название инструкции"
					},
					ctcicc3: {
						zh: "协议类型",
						en: "agreement type",
						vi: "loại thỏa thuận",
						ru: "Тип протокола"
					},
					ctcicc4: {
						zh: "命令类型",
						en: "Command Type",
						vi: "Loại lệnh",
						ru: "Тип команды"
					},
					ctcicc5: {
						zh: "指令内容",
						en: "Instruction content",
						vi: "Nội dung hướng dẫn",
						ru: "Содержание инструкции"
					},
					ctcicc6: {
						zh: "操作",
						en: "operate",
						vi: "vận hành",
						ru: "работать"
					},
					ctcicc7: {
						zh: "编辑",
						en: "edit",
						vi: "biên tập",
						ru: "редактор"
					},
					ctcicc8: {
						zh: "删除",
						en: "delete",
						vi: "xóa bỏ",
						ru: "стирать"
					},
					ctcicc9: {
						zh: "退出编辑",
						en: "Exit Edit",
						vi: "Thoát Chỉnh sửa",
						ru: "Завершите редактирование"
					},
					ctcicc10: {
						zh: "取 消",
						en: "Cancel",
						vi: "Hủy bỏ",
						ru: "отменять"
					},
					ctcicc11: {
						zh: "确 定",
						en: "Sure",
						vi: "Chắc chắn",
						ru: "определять"
					},
					ctcicc12: {
						zh: "字符串",
						en: "String",
						vi: "Chuỗi",
						ru: "строка"
					},
					ctcicc13: {
						zh: "16进制",
						en: "Hexadecimal",
						vi: "thập lục phân",
						ru: "Шестнадцатеричный"
					},
					ctcicc14: {
						zh: "发送成功！",
						en: "Sent successfully!",
						vi: "Gửi thành công!",
						ru: "Отправлено успешно!"
					},
					ctcicc15: {
						zh: "发送失败！",
						en: "Failed to send!",
						vi: "Gửi thất bại!",
						ru: "Не удалось отправить сообщение!"
					},
					ctcicc16: {
						zh: "编辑成功！",
						en: "Edited successfully!",
						vi: "Đã chỉnh sửa thành công!",
						ru: "Отредактировано успешно!"
					},
					ctcicc17: {
						zh: "编辑失败！",
						en: "Edit failed!",
						vi: "Chỉnh sửa không thành công!",
						ru: "Ошибка редактирования!"
					}
				},
				OtherSettings: {
					ctcio1: {
						zh: "输出分辨率:(大于等于屏幕分辨率且不小于256)",
						en: "Output resolution: (greater than or equal to screen resolution and not less than 256)",
						vi: "Độ phân giải đầu ra (lớn hơn hoặc bằng độ phân giải màn hình và không nhỏ hơn 256)",
						ru: "Выходное разрешение: (больше или равно разрешению экрана и не менее 256)"
					},
					ctcio2: {
						zh: "宽 :",
						en: "Width :",
						vi: "Chiều rộng",
						ru: "большой :"
					},
					ctcio3: {
						zh: "请输入宽",
						en: "Please enter width",
						vi: "Vui lòng nhập chiều rộng",
						ru: "Пожалуйста, введите ширину"
					},
					ctcio4: {
						zh: "高 :",
						en: "high :",
						vi: "cao",
						ru: "высота :"
					},
					ctcio5: {
						zh: "请输入高",
						en: "Please enter a high",
						vi: "Vui lòng nhập mức cao",
						ru: "Пожалуйста, введите высокий"
					},
					ctcio6: {
						zh: "刷 新",
						en: "refresh",
						vi: "Làm mới",
						ru: "Освежить"
					},
					ctcio7: {
						zh: "重启后立即生效，是否立即重启？",
						en: "The system will take effect immediately after reboot. Do you want to reboot immediately?",
						vi: "Hệ thống sẽ có hiệu lực ngay sau khi khởi động lại. Bạn có muốn khởi động lại ngay lập tức không?",
						ru: "Он вступит в силу сразу после перезагрузки. Будет ли он перезапущен немедленно?"
					},
					ctcio8: {
						zh: "确定应用！",
						en: "OK to apply!",
						vi: "xác nhận áp dụng",
						ru: "Определите область применения!"
					},
					ctcio9: {
						zh: "应用",
						en: "application",
						vi: "ứng dụng",
						ru: "приложение"
					},
					ctcio10: {
						zh: "软件打折(用于超宽超高屏)",
						en: "Software discounts (for ultra-wide and ultra-tall screens)",
						vi: "Giảm giá phần mềm (cho màn hình siêu rộng và siêu cao)",
						ru: "Скидка на программное обеспечение (для сверхшироких и сверхвысоких экранов)"
					},
					ctcio11: {
						zh: "屏幕类型",
						en: "Screen type",
						vi: "Loại màn hình",
						ru: "Тип экрана"
					},
					ctcio12: {
						zh: "请输入高",
						en: "Please enter a high",
						vi: "Vui lòng nhập mức cao",
						ru: "Пожалуйста, введите высокий"
					},
					ctcio13: {
						zh: "确定应用！",
						en: "OK to apply!",
						vi: "xác nhận áp dụng",
						ru: "Определите область применения!"
					},
					ctcio14: {
						zh: "监控连接状态当断开请选择分钟时自动重连",
						en: "Monitor connection status. When disconnected, please select the minutes to automatically reconnect.",
						vi: "Theo dõi trạng thái kết nối. Khi ngắt kết nối hãy chọn số phút để tự động kết nối lại.",
						ru: "Следите за состоянием соединения и автоматически подключайтесь снова при отключении, пожалуйста, выберите минуты"
					},
					ctcio15: {
						zh: "定时重启",
						en: "Scheduled restart",
						vi: "Khởi động lại theo lịch trình",
						ru: "Синхронизированный перезапуск"
					},
					ctcio16: {
						zh: "设置任意时间点自动重启任务",
						en: "Set up automatic restart of tasks at any time",
						vi: "Thiết lập tự động khởi động lại tác vụ bất cứ lúc nào",
						ru: "Установите любой момент времени для автоматического перезапуска задачи"
					},
					ctcio17: {
						zh: "传感器总开关",
						en: "Sensor master switch",
						vi: "Công tắc cảm biến chính",
						ru: "Главный выключатель датчика"
					},
					ctcio18: {
						zh: "自动亮度开关",
						en: "Automatic brightness switch",
						vi: "Công tắc độ sáng tự động",
						ru: "Автоматический переключатель яркости"
					},
					ctcio19: {
						zh: "不打折",
						en: "no discount",
						vi: "không giảm giá",
						ru: "Без скидки"
					},
					ctcio20: {
						zh: "超长屏",
						en: "Extra long screen",
						vi: "Màn hình siêu dài",
						ru: "Сверхдлинный экран"
					},
					ctcio21: {
						zh: "超宽屏",
						en: "Ultra Wide Screen",
						vi: "Màn hình siêu rộng",
						ru: "Сверхширокий экран"
					},
					ctcio22: {
						zh: "指令设置成功！",
						en: "The command was set successfully!",
						vi: "Lệnh đã được đặt thành công!",
						ru: "Инструкция была успешно выполнена!"
					}
				},
				PanelMonitoring: {
					ctcip1: {
						zh: "每30S自动刷新",
						en: "Automatically refresh every 30S",
						vi: "Tự động làm mới sau mỗi 30 giây",
						ru: "Автоматическое обновление каждые 30 секунд"
					},
					ctcip2: {
						zh: "未接入传感器",
						en: "No sensor connected",
						vi: "Không có cảm biến được kết nối",
						ru: "Не подключен к датчику"
					},
					ctcip3: {
						zh: "刷 新",
						en: "refresh",
						vi: "Làm mới",
						ru: "Освежить"
					},
					ctcip4: {
						zh: "拼命加载中",
						en: "Loading",
						vi: "Đang tải",
						ru: "Отчаянно загружаясь"
					},
					ctcip5: {
						zh: "发送卡接收卡",
						en: "Sending card Receiving card",
						vi: "thẻ phát thẻ nhận",
						ru: "Отправка карточки получение карточки"
					},
					ctcip6: {
						zh: "序号",
						en: "Serial number",
						vi: "Số seri",
						ru: "серийный номер"
					},
					ctcip7: {
						zh: "设备类型",
						en: "Equipment type",
						vi: "Loại thiết bị",
						ru: "Тип устройства"
					},
					ctcip8: {
						zh: "工作状态",
						en: "Working status",
						vi: "Tình trạng làm việc",
						ru: "Рабочее состояние"
					},
					ctcip9: {
						zh: "刷 新",
						en: "refresh",
						vi: "Làm mới",
						ru: "Освежить"
					},
					ctcip10: {
						zh: "屏体温度",
						en: "Screen temperature",
						vi: "Nhiệt độ màn hình",
						ru: "Температура экрана"
					},
					ctcip11: {
						zh: "屏体湿度",
						en: "Screen humidity",
						vi: "Độ ẩm màn hình",
						ru: "Влажность экрана"
					},
					ctcip12: {
						zh: "环境亮度",
						en: "Ambient brightness",
						vi: "Độ sáng xung quanh",
						ru: "Окружающая яркость"
					},
					ctcip13: {
						zh: "烟感",
						en: "Smoke",
						vi: "Đầu báo khói",
						ru: "Ощущение дыма"
					},
					ctcip14: {
						zh: "发送卡",
						en: "Send Card",
						vi: "thẻ phát",
						ru: "Отправить открытку"
					},
					ctcip15: {
						zh: "接收卡",
						en: "receive card",
						vi: "thẻ nhận",
						ru: "Получение карточки"
					}
				},
				RelayControlDetail: {
					ctcir1: {
						zh: "确定",
						en: "Sure",
						vi: "Chắc chắn",
						ru: "уверенный"
					}
				},
				RemoteLock: {
					ctcirl1: {
						zh: "拼命加载中",
						en: "Loading",
						vi: "Đang tải",
						ru: "Отчаянно загружаясь"
					},
					ctcirl2: {
						zh: "设备状态",
						en: "device status",
						vi: "trạng thái thiết bị",
						ru: "Состояние устройства"
					},
					ctcirl3: {
						zh: "序号",
						en: "Serial number",
						vi: "Số seri",
						ru: "серийный номер"
					},
					ctcirl4: {
						zh: "设备类型",
						en: "Equipment type",
						vi: "Loại thiết bị",
						ru: "Тип устройства"
					},
					ctcirl5: {
						zh: "工作状态",
						en: "Working status",
						vi: "Tình trạng làm việc",
						ru: "Рабочее состояние"
					},
					ctcirl6: {
						zh: "立即锁定",
						en: "Lock now",
						vi: "Khóa ngay",
						ru: "Запереть сейчас же"
					},
					ctcirl7: {
						zh: "设置锁定计划",
						en: "Setting up a lock schedule",
						vi: "Thiết lập lịch khóa",
						ru: "Разработайте план локаута"
					},
					ctcirl8: {
						zh: "立即解锁",
						en: "Unlock now",
						vi: "Mở khóa ngay bây giờ",
						ru: "Разблокируй сейчас"
					},
					ctcirl9: {
						zh: "请输入密码",
						en: "Please enter your password",
						vi: "Vui lòng nhập mật khẩu của bạn",
						ru: "Пожалуйста, введите пароль"
					},
					ctcirl10: {
						zh: "设置密码",
						en: "set password",
						vi: "đặt mật khẩu",
						ru: "Установить пароль"
					},
					ctcirl11: {
						zh: "验证密码",
						en: "verify password",
						vi: "Xác nhận lại mật khẩu",
						ru: "Подтвердите пароль"
					},
					ctcirl12: {
						zh: "锁定计划",
						en: "Locking plan",
						vi: "Kế hoạch khóa",
						ru: "План закрепления"
					},
					ctcirl13: {
						zh: "锁定",
						en: "locking",
						vi: "khóa",
						ru: "блокировка"
					},
					ctcirl14: {
						zh: "取消",
						en: "Cancel",
						vi: "Hủy bỏ",
						ru: "отменять"
					},
					ctcirl15: {
						zh: "设置锁定计划",
						en: "Setting up a lock schedule",
						vi: "Thiết lập lịch khóa",
						ru: "Разработайте план локаута"
					},
					ctcirl16: {
						zh: "选择日期时间",
						en: "Select date and time",
						vi: "Chọn ngày và giờ",
						ru: "Выберите дату и время"
					},
					ctcirl17: {
						zh: "注:设备将在预设的计划时刻进行上锁。",
						en: "Note: The device will lock at the preset scheduled time.",
						vi: "Lưu ý Thiết bị sẽ khóa vào thời gian đã định trước.",
						ru: "Примечание: Устройство будет заблокировано в заранее установленное время по расписанию."
					},
					ctcirl18: {
						zh: "接收卡",
						en: "receive card",
						vi: "thẻ nhận",
						ru: "Получение карточки"
					},
					ctcirl19: {
						zh: "发送卡",
						en: "Send Card",
						vi: "thẻ phát",
						ru: "Отправить открытку"
					},
					ctcirl20: {
						zh: "工程锁设置成功",
						en: "Engineering lock is set successfully",
						vi: "Khóa kỹ thuật được đặt thành công",
						ru: "Инженерный шлюз был успешно установлен"
					},
					ctcirl21: {
						zh: "验证失败",
						en: "verification failed",
						vi: "xác minh không hoàn thành",
						ru: "Не удалось выполнить проверку"
					}
				}
			},
			AddBatchDevice: {
				ctca1: {
					zh: "数据拼命解析中...",
					en: "The data is being analyzed...",
					vi: "Dữ liệu đang được phân tích...",
					ru: "Эти данные в настоящее время анализируются..."
				},
				ctca2: {
					zh: "导入",
					en: "Import",
					vi: "Nhập",
					ru: "импортировать"
				},
				ctca3: {
					zh: "设备导入模板.xlsx",
					en: "Equipment import template.xlsx",
					vi: "Mẫu nhập thiết bị.xlsx",
					ru: "Шаблон импорта устройства.xlsx"
				},
				ctca4: {
					zh: "下载模板",
					en: "Download the template",
					vi: "Tải xuống mẫu",
					ru: "Скачать шаблон"
				}
			},
			AddDevice: {
				ctcad1: {
					zh: "设备名称",
					en: "Device Name",
					vi: "Tên thiết bị",
					ru: "Имя устройства"
				},
				ctcad2: {
					zh: "组织结构",
					en: "Organizational Structure",
					vi: "Cơ cấu tổ chức",
					ru: "структура"
				},
				ctcad3: {
					zh: "请选择组织结构",
					en: "Please select your organizational structure",
					vi: "Vui lòng chọn cơ cấu tổ chức của bạn",
					ru: "Пожалуйста, выберите организационную структуру"
				},
				ctcad4: {
					zh: "分辨率",
					en: "Resolution",
					vi: "Độ phân giải",
					ru: "разрешение"
				},
				ctcad5: {
					zh: "请选择分辨率",
					en: "Please select resolution",
					vi: "Vui lòng chọn độ phân giải",
					ru: "Пожалуйста, выберите разрешение"
				},
				ctcad6: {
					zh: "自定义",
					en: "customize",
					vi: "tùy chỉnh",
					ru: "настроить"
				},
				ctcad7: {
					zh: "设备类型",
					en: "Equipment type",
					vi: "Loại thiết bị",
					ru: "Тип устройства"
				},
				ctcad8: {
					zh: "请选择设备类型",
					en: "Please select device type",
					vi: "Vui lòng chọn loại thiết bị",
					ru: "Пожалуйста, выберите тип устройства"
				},
				ctcad9: {
					zh: "密匙",
					en: "Key",
					vi: "phím",
					ru: "ключ"
				},
				ctcad10: {
					zh: "备注",
					en: "Remark",
					vi: "Nhận xét",
					ru: "Замечания"
				},
				ctcad11: {
					zh: "设备名称不能为空",
					en: "Device name cannot be empty",
					vi: "Tên thiết bị không được để trống",
					ru: "Имя устройства не может быть пустым"
				},
				ctcad12: {
					zh: "组织结构不能为空",
					en: "Organization structure cannot be empty",
					vi: "Cơ cấu tổ chức không được để trống",
					ru: "Организационная структура не может быть пустой"
				},
				ctcad13: {
					zh: "SN不能为空",
					en: "SN cannot be empty",
					vi: "SN không thể trống",
					ru: "SN не может быть пустым"
				},
				ctcad14: {
					zh: "屏幕分辨率不能为空",
					en: "Screen resolution cannot be empty",
					vi: "Độ phân giải màn hình không được để trống",
					ru: "Разрешение экрана не может быть пустым"
				},
				ctcad15: {
					zh: "分辨率W为空",
					en: "Resolution W is empty",
					vi: "Độ phân giải W trống",
					ru: "Разрешение W пустое"
				},
				ctcad16: {
					zh: "分辨率H为空",
					en: "Resolution H is empty",
					vi: "Độ phân giải H trống",
					ru: "Разрешение H пустое"
				},
				ctcad17: {
					zh: "位置X为空",
					en: "Position X is empty",
					vi: "Vị trí X trống",
					ru: "Позиция X пуста"
				},
				ctcad18: {
					zh: "位置Y为空",
					en: "Position Y is empty",
					vi: "Vị trí Y trống",
					ru: "Позиция Y пуста"
				},
				ctcad19: {
					zh: "本地分辨率存在..",
					en: "Native resolution exists..",
					vi: "Độ phân giải gốc tồn tại ..",
					ru: "Существует локальное разрешение.."
				},
				ctcad20: {
					zh: "编辑参数.....",
					en: "Edit Parameters...",
					vi: "Chỉnh sửa thông số...",
					ru: "Отредактируйте параметры....."
				}
			},
			DeviceDetail: {
				ctcde1: {
					zh: "暂无数据",
					en: "No data",
					vi: "Không có dữ liệu",
					ru: "Нет доступных данных"
				}
			},
			DeviceDetailOpen: {
				ctcddo1: {
					zh: "截屏",
					en: "screenshot",
					vi: "ảnh chụp màn hình",
					ru: "скриншот"
				},
				ctcddo2: {
					zh: "屏体监控",
					en: "Screen monitoring",
					vi: "Giám sát màn hình",
					ru: "Мониторинг экрана"
				},
				ctcddo3: {
					zh: "其他设置",
					en: "other settings",
					vi: "các thiết lập khác",
					ru: "Другие настройки"
				},
				ctcddo4: {
					zh: "暂无数据",
					en: "No data",
					vi: "Không có dữ liệu",
					ru: "Нет доступных данных"
				},
				ctcddo5: {
					zh: "无需升级",
					en: "No upgrade required",
					vi: "Không cần nâng cấp",
					ru: "Нет необходимости в обновлении"
				},
				ctcddo6: {
					zh: "上传完成",
					en: "upload completed",
					vi: "Hoàn tất tải lên",
					ru: "Загрузка завершена"
				},
				ctcddo7: {
					zh: "定时播放",
					en: "Scheduled playback",
					vi: "Phát lại theo lịch trình",
					ru: "Синхронизированное воспроизведение"
				},
				ctcddo8: {
					zh: "WIFI网络",
					en: "WIFI network",
					vi: "Mạng wifi",
					ru: "Сеть Wi-FI"
				},
				ctcddo9: {
					zh: "有线网络",
					en: "Wired network",
					vi: "Mạng có dây",
					ru: "Проводная сеть"
				},
				ctcddo10: {
					zh: "同步播放",
					en: "Synchronous playback",
					vi: "Phát lại đồng bộ",
					ru: "Синхронное воспроизведение"
				},
				ctcddo11: {
					zh: "websocket截图",
					en: "websocket screenshot",
					vi: "ảnh chụp màn hình websocket",
					ru: "скриншот веб-сокета"
				}
			},
			EditTimePlan: {
				ctce1: {
					zh: "定时播放编辑",
					en: "Timed playback editing",
					vi: "Chỉnh sửa phát lại theo thời gian",
					ru: "Редактирование воспроизведения по времени"
				},
				ctce2: {
					zh: "名称",
					en: "name",
					vi: "tên",
					ru: "название"
				},
				ctce3: {
					zh: "执行时间",
					en: "execution time",
					vi: "thời gian thực hiện",
					ru: "Время выполнения"
				},
				ctce4: {
					zh: "开始时间",
					en: "Starting time",
					vi: "Thời gian bắt đầu",
					ru: "Время начала"
				},
				ctce5: {
					zh: "至",
					en: "to",
					vi: "ĐẾN",
					ru: "до"
				},
				ctce6: {
					zh: "结束时间",
					en: "End Time",
					vi: "Thời gian kết thúc",
					ru: "Время окончания"
				},
				ctce7: {
					zh: "有效日期",
					en: "Effective Date",
					vi: "Ngày có hiệu lực",
					ru: "Дата вступления в силу"
				}
			},
			HandleOrder: {
				ctch1: {
					zh: "发布紧急信息",
					en: "Release emergency information",
					vi: "Công bố thông tin khẩn cấp",
					ru: "Публиковать информацию о чрезвычайных ситуациях"
				},
				ctch2: {
					zh: "取消紧急信息",
					en: "Cancel emergency information",
					vi: "Hủy thông tin khẩn cấp",
					ru: "Отменить экстренную информацию"
				},
				ctch3: {
					zh: "截屏所有选中设备？",
					en: "Take screenshot of all selected devices?",
					vi: "Chụp ảnh màn hình của tất cả các thiết bị đã chọn?",
					ru: "Сделайте скриншоты всех выбранных устройств?"
				},
				ctch4: {
					zh: "启用云平台看护",
					en: "Enable cloud platform maintenance",
					vi: "Kích hoạt bảo trì nền tảng đám mây",
					ru: "Включить поддержку облачной платформы"
				},
				ctch5: {
					zh: "监控云平台连接状态，当连接断开请选择时，盒子自动尝试重启再登录。",
					en: "Monitor the cloud platform connection status. When the connection is disconnected, please select it and the box will automatically try to restart and log in again.",
					vi: "Theo dõi trạng thái kết nối nền tảng đám mây. Khi kết nối bị ngắt, vui lòng chọn nó và hộp sẽ tự động khởi động lại và đăng nhập lại.",
					ru: "Следите за состоянием подключения к облачной платформе. Когда подключение будет отключено, пожалуйста, установите флажок, после чего автоматически попытайтесь перезагрузиться, а затем войдите в систему."
				},
				ctch6: {
					zh: "开启上传",
					en: "Enable Upload",
					vi: "Bật tải lên",
					ru: "Открыть загрузку"
				},
				ctch7: {
					zh: "关闭上传",
					en: "Close Upload",
					vi: "Đóng tải lên",
					ru: "Закрыть загрузку"
				},
				ctch8: {
					zh: "全屏",
					en: "full screen",
					vi: "toàn màn hình",
					ru: "Полноэкранный режим"
				},
				ctch9: {
					zh: "信息内容",
					en: "information",
					vi: "thông tin",
					ru: "Информационное наполнение"
				},
				ctch10: {
					zh: "选择文本",
					en: "Select text",
					vi: "Chọn văn bản",
					ru: "Выделите текст"
				},
				ctch11: {
					zh: "请输入内容",
					en: "Please enter content",
					vi: "Vui lòng nhập nội dung",
					ru: "Пожалуйста, введите содержание"
				},
				ctch12: {
					zh: "文字大小",
					en: "font size",
					vi: "cỡ chữ",
					ru: "Размер текста"
				},
				ctch13: {
					zh: "文字颜色",
					en: "Text Color",
					vi: "Màu chữ",
					ru: "Цвет текста"
				},
				ctch14: {
					zh: "文字背景",
					en: "Text background",
					vi: "Nền chữ",
					ru: "Текстовый фон"
				},
				ctch15: {
					zh: "持续时间",
					en: "duration",
					vi: "khoảng thời gian",
					ru: "продолжительность"
				},
				ctch16: {
					zh: "任意时间点",
					en: "Any time point",
					vi: "Bất kỳ thời điểm nào",
					ru: "В любой момент времени"
				},
				ctch17: {
					zh: "播出类型",
					en: "Broadcast Type",
					vi: "Loại phát sóng",
					ru: "Тип широковещательной передачи"
				},
				ctch18: {
					zh: "声音控制",
					en: "voice control",
					vi: "điều khiển giọng nói",
					ru: "Управление звуком"
				},
				ctch19: {
					zh: "请选择",
					en: "please choose",
					vi: "xin vui lòng chọn",
					ru: "Пожалуйста выберите"
				},
				ctch20: {
					zh: "立即发送",
					en: "send immediately",
					vi: "gửi ngay lập tức",
					ru: "Отправляйте прямо сейчас"
				},
				ctch21: {
					zh: "取消",
					en: "Cancel",
					vi: "Hủy bỏ",
					ru: "отменять"
				},
				ctch22: {
					zh: "确定取消所选终端的紧急信息？",
					en: "Are you sure you want to cancel the emergency information for the selected terminal?",
					vi: "Bạn có chắc chắn muốn hủy thông tin khẩn cấp cho thiết bị đầu cuối đã chọn không?",
					ru: "Вы уверены, что хотите отменить экстренную информацию о выбранном терминале?"
				},
				ctch23: {
					zh: "版式选择",
					en: "Layout Selection",
					vi: "Lựa chọn bố cục",
					ru: "Выбор макета"
				},
				ctch24: {
					zh: "请选择",
					en: "please choose",
					vi: "xin vui lòng chọn",
					ru: "Пожалуйста выберите"
				},
				ctch25: {
					zh: "模式选择",
					en: "Mode Selection",
					vi: "Chế độ lựa chọn",
					ru: "Выбор режима"
				},
				ctch26: {
					zh: "模式",
					en: "model",
					vi: "Chế độ",
					ru: "режим"
				},
				ctch27: {
					zh: "开启全局流媒体播放",
					en: "Enable global streaming",
					vi: "Bật phát trực tuyến toàn cầu",
					ru: "Включите глобальное потоковое воспроизведение мультимедиа"
				},
				ctch28: {
					zh: "请输入内容",
					en: "Please enter content",
					vi: "Vui lòng nhập nội dung",
					ru: "Пожалуйста, введите содержание"
				},
				ctch29: {
					zh: "请输入流地址",
					en: "Please enter the stream address",
					vi: "Vui lòng nhập địa chỉ luồng",
					ru: "Пожалуйста, введите адрес трансляции"
				},
				ctch30: {
					zh: "紧急消息",
					en: "Urgent Message",
					vi: "Thông báo khẩn cấp",
					ru: "Срочное сообщение"
				},
				ctch31: {
					zh: "亮度调节",
					en: "Dimming",
					vi: "Làm mờ",
					ru: "Регулировка яркости"
				},
				ctch32: {
					zh: "音量调节",
					en: "Volume adjustment",
					vi: "Điều chỉnh âm lượng",
					ru: "Регулировка громкости"
				},
				ctch33: {
					zh: "关闭屏幕",
					en: "Turn off screen",
					vi: "Tắt màn hình",
					ru: "Выключите экран"
				},
				ctch34: {
					zh: "开启屏幕",
					en: "Turn on screen",
					vi: "Bật màn hình",
					ru: "Включите экран"
				},
				ctch35: {
					zh: "全屏显示",
					en: "full-screen display",
					vi: "hiển thị toàn màn hình",
					ru: "Полноэкранный дисплей"
				},
				ctch36: {
					zh: "滚动显示",
					en: "Scroll Display",
					vi: "Hiển thị cuộn",
					ru: "Дисплей с прокруткой"
				},
				ctch37: {
					zh: "选项1",
					en: "Option 1",
					vi: "lựa chọn 1",
					ru: "Вариант 1"
				},
				ctch38: {
					zh: "请选择0-100之间'",
					en: "Please select between 0-100",
					vi: "Vui lòng chọn trong khoảng 0-100",
					ru: "Пожалуйста, выберите значение от 0 до 100"
				},
				ctch39: {
					zh: "保存成功",
					en: "Saved successfully",
					vi: "đã lưu thành công",
					ru: "Успешно сохранен"
				},
				ctch40: {
					zh: "模板已存在,请更改名称",
					en: "The template already exists, please change the name",
					vi: "Mẫu đã tồn tại, vui lòng đổi tên",
					ru: "Шаблон уже существует, пожалуйста, измените название"
				},
				ctch41: {
					zh: "取消成功!",
					en: "Cancel success!",
					vi: "Hủy bỏ thành công!",
					ru: "Отмена прошла успешно!"
				},
				ctch42: {
					zh: "请设置数值参数",
					en: "Please set the numerical parameters",
					vi: "Hãy thiết lập các thông số số",
					ru: "Пожалуйста, задайте числовые параметры"
				},
				ctch43: {
					zh: "信息内容不能为空！",
					en: "The information content cannot be empty!",
					vi: "Nội dung thông tin không được để trống!",
					ru: "Информационное наполнение не может быть пустым!"
				},
				ctch44: {
					zh: "确定立即发送紧急信息?",
					en: "Are you sure you want to send an emergency message immediately?",
					vi: "Bạn có chắc chắn muốn gửi tin nhắn khẩn cấp ngay lập tức không?",
					ru: "Вы уверены, что нужно немедленно отправить экстренное сообщение?"
				},
				ctch45: {
					zh: "紧急信息",
					en: "Emergency Information",
					vi: "Thông tin khẩn cấp",
					ru: "Экстренная информация"
				},
				ctch46: {
					zh: "发送成功!",
					en: "Sent successfully!",
					vi: "Gửi thành công!",
					ru: "Отправлено успешно!"
				},
				ctch47: {
					zh: "截屏",
					en: "screenshot",
					vi: "ảnh chụp màn hình",
					ru: "скриншот"
				},
				ctch48: {
					zh: "云看护",
					en: "Cloud Care",
					vi: "Chăm sóc đám mây",
					ru: "Уход за облаком"
				},
				ctch49: {
					zh: "云看护开关",
					en: "Cloud Guardian Switch",
					vi: "Công tắc bảo vệ đám mây",
					ru: "Карданный переключатель"
				},
				ctch50: {
					zh: "日志上传设置",
					en: "Log upload settings",
					vi: "Cài đặt tải lên nhật ký",
					ru: "Настройки загрузки журнала"
				},
				ctch51: {
					zh: "紧急消息发布",
					en: "Emergency message release",
					vi: "Phát hành tin nhắn khẩn cấp",
					ru: "Экстренный выпуск новостей"
				},
				ctch52: {
					zh: "紧急消息取消",
					en: "Emergency message cancellation",
					vi: "Hủy tin nhắn khẩn cấp",
					ru: "Экстренное сообщение отменено"
				},
				ctch53: {
					zh: "紧急消息模式切换",
					en: "Emergency message mode switch",
					vi: "Chuyển đổi chế độ tin nhắn khẩn cấp",
					ru: "Переключатель режима аварийного сообщения"
				},
				ctch54: {
					zh: "紧急版式",
					en: "Emergency Layout",
					vi: "Bố cục khẩn cấp",
					ru: "Аварийная планировка"
				},
				ctch55: {
					zh: "已发送",
					en: "Has been sent",
					vi: "Đã được gửi đi",
					ru: "Отправлено"
				}
			}
		},
		Control: {
			ctco1: {
				zh: "安装日期",
				en: "Installation Date",
				vi: "Ngày cài đặt",
				ru: "Дата установки"
			},
			ctco2: {
				zh: "选择日期时间",
				en: "Select date and time",
				vi: "Chọn ngày và giờ",
				ru: "Выберите дату и время"
			},
			ctco3: {
				zh: "测试",
				en: "test",
				vi: "Kiểm tra",
				ru: "проверка"
			},
			ctco4: {
				zh: "确定",
				en: "Sure",
				vi: "Chắc chắn",
				ru: "уверенный"
			},
			ctco5: {
				zh: "数据拼命解析中",
				en: "Data is being analyzed",
				vi: "Dữ liệu đang được phân tích",
				ru: "Данные анализируются"
			},
			ctco6: {
				zh: "导入",
				en: "Import",
				vi: "Nhập khẩu",
				ru: "импортировать"
			},
			ctco7: {
				zh: "下载模板",
				en: "Download the template",
				vi: "Tải xuống mẫu",
				ru: "Скачать шаблон"
			},
			ctco8: {
				zh: "请检查格式",
				en: "Please check the format",
				vi: "Vui lòng kiểm tra định dạng",
				ru: "Пожалуйста, проверьте формат"
			}
		}
	},
	router: {
		index: {
			ri1: {
				zh: "帮助",
				en: "help",
				vi: "giúp đỡ",
				ru: "помогать"
			},
			ri2: {
				zh: "素材管理",
				en: "Material Management",
				vi: "Quản lý vật liệu",
				ru: "Управление материальными ресурсами"
			},
			ri3: {
				zh: "媒体列表",
				en: "Media List",
				vi: "Danh sách phương tiện",
				ru: "Список носителей"
			},
			ri4: {
				zh: "新媒体列表",
				en: "New Media List",
				vi: "Danh sách phương tiện mới",
				ru: "Список новых носителей"
			},
			ri5: {
				zh: "媒体上传",
				en: "Media Upload",
				vi: "Tải lên phương tiện",
				ru: "Загрузка мультимедиа"
			},
			ri6: {
				zh: "节目管理",
				en: "Program Management",
				vi: "Quản lý chương trình",
				ru: "Управление программами"
			},
			ri7: {
				zh: "节目编辑",
				en: "Program Editing",
				vi: "Chỉnh sửa chương trình",
				ru: "Редактор программ"
			},
			ri8: {
				zh: "高级发布",
				en: "Advanced Publishing",
				vi: "Xuất bản nâng cao",
				ru: "Расширенный выпуск"
			},
			ri9: {
				zh: "插播管理",
				en: "Interlude Management",
				vi: "Quản lý xen kẽ",
				ru: "Промежуточное управление"
			},
			ri10: {
				zh: "权限配置",
				en: "Rights Profile",
				vi: "Hồ sơ quyền",
				ru: "Настройка разрешений"
			},
			ri11: {
				zh: "新建插播",
				en: "Create a new insert",
				vi: "Tạo một phần chèn mới",
				ru: "Новый интерстициальный"
			},
			ri12: {
				zh: "节目编辑窗口",
				en: "Program editing window",
				vi: "Cửa sổ soạn thảo chương trình",
				ru: "Окно редактирования программы"
			},
			ri13: {
				zh: "节目发布窗口",
				en: "Program release window",
				vi: "Cửa sổ phát hành chương trình",
				ru: "Окно выпуска программы"
			},
			ri14: {
				zh: "终端管理",
				en: "Terminal Management",
				vi: "Quản lý thiết bị đầu cuối",
				ru: "Управление терминалом"
			},
			ri15: {
				zh: "审核管理",
				en: "Audit Management",
				vi: "Quản lý kiểm toán",
				ru: "Управление аудитом"
			},
			ri16: {
				zh: "素材审核",
				en: "Material review",
				vi: "Đánh giá tài liệu",
				ru: "Обзор материалов"
			},
			ri17: {
				zh: "节目审核",
				en: "Program Review",
				vi: "Đánh giá chương trình",
				ru: "Обзор программы"
			},
			ri18: {
				zh: "发布审核",
				en: "Release Review",
				vi: "Đánh giá phát hành",
				ru: "Обзор выпуска"
			},
			ri19: {
				zh: "审核管理",
				en: "Audit Management",
				vi: "Quản lý kiểm toán",
				ru: "Управление аудитом"
			},
			ri20: {
				zh: "日志管理",
				en: "Log Management",
				vi: "Quản lý nhật ký",
				ru: "Управление журналами"
			},
			ri21: {
				zh: "登录日志",
				en: "Login Log",
				vi: "Đăng nhập Nhật ký",
				ru: "Журнал входа в систему"
			},
			ri22: {
				zh: "操作日志",
				en: "Operation log",
				vi: "Nhật ký hoạt động",
				ru: "Журнал операций"
			},
			ri23: {
				zh: "终端日志",
				en: "Terminal log",
				vi: "Nhật ký thiết bị đầu cuối",
				ru: "Журнал регистрации терминала"
			},
			ri24: {
				zh: "终端管理",
				en: "Terminal Management",
				vi: "Quản lý thiết bị đầu cuối",
				ru: "Управление терминалом"
			},
			ri25: {
				zh: "终端详情",
				en: "Terminal Details",
				vi: "Chi tiết thiết bị đầu cuối",
				ru: "Сведения о терминале"
			},
			ri26: {
				zh: "获取设备",
				en: "Get the device",
				vi: "Nhận thiết bị",
				ru: "Получить оборудование"
			},
			ri27: {
				zh: "高级管理",
				en: "Senior Management",
				vi: "Quản lí cấp cao",
				ru: "Высшее руководство"
			},
			ri28: {
				zh: "组织结构",
				en: "Organizational Structure",
				vi: "Cơ cấu tổ chức",
				ru: "структура"
			},
			ri29: {
				zh: "媒体目录管理",
				en: "Media Catalog Management",
				vi: "Quản lý danh mục phương tiện truyền thông",
				ru: "Управление каталогом мультимедиа"
			},
			ri30: {
				zh: "用户管理",
				en: "User Management",
				vi: "Quản lý người dùng",
				ru: "Управление пользователями"
			},
			ri31: {
				zh: "角色管理",
				en: "Role Management",
				vi: "Quản lý vai trò",
				ru: "Управление ролями"
			},
			ri32: {
				zh: "系统设置",
				en: "System Settings",
				vi: "Cài đặt hệ thống",
				ru: "Системные настройки"
			},
			ri33: {
				zh: "节点管理",
				en: "Node Management",
				vi: "Quản lý nút",
				ru: "Управление узлами"
			},
			ri34: {
				zh: "个人中心",
				en: "Personal Center",
				vi: "Trung tâm cá nhân",
				ru: "Персональный центр"
			},
			ri35: {
				zh: "权限配置",
				en: "Rights Profile",
				vi: "Hồ sơ quyền",
				ru: "Настройка разрешений"
			},
			ri36: {
				zh: "审核设置",
				en: "Audit settings",
				vi: "Cài đặt kiểm tra",
				ru: "Настройки аудита"
			},
			ri37: {
				zh: "推荐码",
				en: "Referral Code",
				vi: "Mã giới thiệu",
				ru: "Рекомендательный код"
			},
			ri38: {
				zh: "紧急内容配置",
				en: "Emergency content configuration",
				vi: "Cấu hình nội dung khẩn cấp",
				ru: "Настройка аварийного содержимого"
			},
			ri39: {
				zh: "断点续传测试",
				en: "Breakpoint resume test",
				vi: "Kiểm tra tiếp tục điểm dừng",
				ru: "Проверка возобновления работы точки останова"
			}
		}
	},
	views: {
		Login: {
			vl1: {
				zh: "请输入服务器地址",
				en: "Please enter the server address",
				vi: "Vui lòng nhập địa chỉ máy chủ",
				ru: "Пожалуйста, введите адрес сервера"
			},
			vl2: {
				zh: "进 入",
				en: "Enter",
				vi: "nhập",
				ru: "входить"
			},
			vl3: {
				zh: "历史访问记录",
				en: "Historical access records",
				vi: "Hồ sơ truy cập lịch sử",
				ru: "Историческая запись доступа"
			},
			vl4: {
				zh: "清除",
				en: "Clear",
				vi: "xoá",
				ru: "очистить"
			},
			vl5: {
				zh: "修改服务器地址",
				en: "Modify the server address",
				vi: "Sửa đổi địa chỉ máy chủ",
				ru: "Изменить адрес сервера"
			},
			vl6: {
				zh: "账户不能为空",
				en: "Account cannot be empty",
				vi: "Tài khoản không thể trống",
				ru: "Учетная запись не может быть пустой"
			},
			vl7: {
				zh: "密码不能为空",
				en: "password can not be blank",
				vi: "mật khẩu không thể để trống",
				ru: "Пароль не может быть пустым"
			},
			vl8: {
				zh: "验证码输入错误",
				en: "incorrect verification code",
				vi: "Mã xác minh không chính xác",
				ru: "Ошибка при вводе проверочного кода"
			},
			vl9: {
				zh: "浏览器语言是中文",
				en: "The browser language is Chinese",
				vi: "Ngôn ngữ trình duyệt là tiếng Trung Quốc",
				ru: "Язык браузера - китайский"
			},
			vl10: {
				zh: "浏览器语言是英文",
				en: "The browser language is English",
				vi: "Ngôn ngữ trình duyệt là tiếng Anh",
				ru: "Язык браузера - английский"
			},
			vl11: {
				zh: "浏览器语言是其它",
				en: "Browser language is Other",
				vi: "Ngôn ngữ trình duyệt là Khác",
				ru: "Язык браузера - другой"
			},
			vl12: {
				zh: "提示",
				en: "hint",
				vi: "gợi ý",
				ru: "подсказка"
			},
			vl13: {
				zh: "为了保证系统功能正常使用，建议您使用<a target=_blank href='https://www.google.cn/intl/zh-CN/chrome/'>Chrome浏览器</a>最新版本进行访问!",
				en: "In order to ensure the normal use of system functions, it is recommended that you use the latest version of <a target=_blank href='https://www.google.cn/intl/zh-CN/chrome/'> to access!",
				vi: "Để đảm bảo các chức năng của hệ thống có thể sử dụng bình thường, bạn nên sử dụng phiên bản mới nhất của &lt;<a target=_blank href='https://www.google.cn/intl/zh-CN/chrome/'> để truy cập!",
				ru: "Чтобы обеспечить нормальное использование системных функций, рекомендуется использовать <a target=_blank href='https://www.google.cn/intl/zh-CN/chrome/'> Доступна последняя версия!"
			}
		},
		Mytest: {
			vm1: {
				zh: "点击上传",
				en: "Click Upload",
				vi: "Nhấp vào Tải lên",
				ru: "Нажмите кнопку загрузить"
			}
		}
	}
};


const object = flatObjectAll(language);
const languages = { zh: {}, en: {}, vi: {}, ru: {} };

for (const key in object) {
  if (Object.hasOwnProperty.call(object, key)) {
    const { zh, en, vi, ru } = object[key];
    languages['zh'][key] = zh;
    languages['en'][key] = en;
    languages['vi'][key] = vi;
    languages['ru'][key] = ru;
  }
}

export default languages;
